// -*- coding: utf-8 -*-
// @charset UTF-8
// NOTE: This file contains emoji characters. Ensure your editor uses UTF-8 encoding.

import React, { useState, useRef, useEffect, useCallback } from 'react';

const SAUCES = [
  // Cream based sauces
  { id: 1, name: 'Mayo', emoji: '\uD83E\uDD5A', color: '#FEF3C7', category: 'Cream', description: 'Creamy diplomat that plays well with everyone.' },
  { id: 2, name: 'Ranch', emoji: '\uD83E\uDD5B', color: '#F5F5DC', category: 'Cream', description: 'Midwestern icon that goes on literally everything.' },
  { id: 3, name: 'Tartar', emoji: '\uD83D\uDC1F', color: '#FEF9C3', category: 'Cream', description: 'Fish\'s best friend, chunky and proud.' },
  { id: 4, name: 'Tzatziki', emoji: '\uD83E\uDD52', color: '#E0F2FE', category: 'Cream', description: 'Cool cucumber vibes from Greece.' },
  { id: 5, name: 'Alfredo', emoji: '\uD83E\uDDC0', color: '#FEFCE8', category: 'Cream', description: 'Butter and cheese doing their best work.' },
  { id: 6, name: 'Blue Cheese', emoji: '\uD83E\uDDC0', color: '#DBEAFE', category: 'Cream', description: 'Funky, divisive, and proud of it.' },
  { id: 7, name: 'Thousand Island', emoji: '\uD83C\uDFDD\uFE0F', color: '#FDBA74', category: 'Cream', description: 'The secret Big Mac ingredient.' },
  { id: 8, name: 'Caesar', emoji: '\uD83E\uDD57', color: '#FEF3C7', category: 'Cream', description: 'Anchovy-powered salad royalty.' },
  { id: 9, name: 'Frite Sauce', emoji: '\uD83C\uDF5F', color: '#FEF9C3', category: 'Cream', description: 'Dutch fry-dipping essential.' },
  { id: 10, name: 'Remoulade', emoji: '\uD83E\uDD90', color: '#FEF3C7', category: 'Cream', description: 'Mayo\'s fancy French cousin with capers.' },
  { id: 11, name: 'Joppie', emoji: '\uD83C\uDDF3\uD83C\uDDF1', color: '#FDE68A', category: 'Cream', description: 'Dutch curry-onion mayo magic.' },
  { id: 12, name: 'Samurai', emoji: '\u2694\uFE0F', color: '#FED7AA', category: 'Cream', description: 'Spicy mayo with a Belgian twist.' },
  { id: 13, name: 'Andalouse', emoji: '\uD83E\uDED1', color: '#FDBA74', category: 'Cream', description: 'Belgian pepper-tomato mayo blend.' },
  { id: 14, name: 'Queso', emoji: '\uD83E\uDDC0', color: '#FDE047', category: 'Cream', description: 'Liquid gold for dipping everything.' },
  { id: 15, name: 'Fondue', emoji: '\uD83E\uDED5', color: '#FEF9C3', category: 'Cream', description: 'Swiss cheese melted into social ritual.' },
  { id: 16, name: 'Garlic Sauce', emoji: '\uD83E\uDDC4', color: '#FFFBEB', category: 'Cream', description: 'Creamy garlic punch for kebabs.' },
  
  // Oil based sauces
  { id: 17, name: 'Aioli', emoji: '\uD83E\uDDC4', color: '#FFFBEB', category: 'Oil', description: 'Mayo\'s sophisticated European cousin.' },
  { id: 18, name: 'Chimichurri', emoji: '\uD83C\uDDE6\uD83C\uDDF7', color: '#22C55E', category: 'Oil', description: 'Argentinian herb party for your steak.' },
  { id: 19, name: 'Curry Sauce', emoji: '\uD83C\uDF5B', color: '#F59E0B', category: 'Oil', description: 'British chip shop essential.' },
  { id: 20, name: 'Pesto', emoji: '\uD83C\uDF3F', color: '#65A30D', category: 'Oil', description: 'Basil-forward and unapologetically Italian.' },
  
  // Soy based sauces
  { id: 21, name: 'Soy Sauce', emoji: '\uD83E\uDD62', color: '#1C1917', category: 'Soy', description: 'Ancient wisdom in liquid form.' },
  { id: 22, name: 'Hoisin', emoji: '\uD83E\uDD61', color: '#292524', category: 'Soy', description: 'Sweet, thick, and essential for Peking duck.' },
  { id: 23, name: 'Teriyaki', emoji: '\uD83C\uDDEF\uD83C\uDDF5', color: '#44403C', category: 'Soy', description: 'Sweet-savory glazed perfection.' },
  
  // Vinegar based sauces
  { id: 24, name: 'Ketchup', emoji: '\uD83C\uDF45', color: '#DC2626', category: 'Vinegar', description: 'The ultimate crowd-pleaser, reliable to a fault.' },
  { id: 25, name: 'Mustard', emoji: '\uD83D\uDFE1', color: '#EAB308', category: 'Vinegar', description: 'Sharp, tangy, and refuses to be ignored.' },
  { id: 26, name: 'Hot Sauce', emoji: '\uD83C\uDF36\uFE0F', color: '#EA580C', category: 'Vinegar', description: 'Lives for chaos and the thrill of the burn.' },
  { id: 27, name: 'BBQ Sauce', emoji: '\uD83D\uDD25', color: '#78350F', category: 'Vinegar', description: 'Sweet, smoky, and deeply American.' },
  { id: 28, name: 'Sriracha', emoji: '\uD83D\uDC13', color: '#B91C1C', category: 'Vinegar', description: 'The rooster that conquered the world.' },
  { id: 29, name: 'Worcestershire', emoji: '\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F', color: '#1C1917', category: 'Vinegar', description: 'Fermented mystery in every dash.' },
  { id: 30, name: 'Buffalo', emoji: '\uD83E\uDDAC', color: '#F97316', category: 'Vinegar', description: 'Hot sauce and butter\'s perfect marriage.' },
  { id: 31, name: 'Cocktail Sauce', emoji: '\uD83E\uDDA4', color: '#EF4444', category: 'Vinegar', description: 'Shrimp\'s tangy red carpet.' },
  { id: 32, name: 'Sweet & Sour', emoji: '\uD83E\uDD61', color: '#F472B6', category: 'Vinegar', description: 'Chinese takeout nostalgia in every bite.' },
  { id: 33, name: 'Chick-fil-A', emoji: '\uD83D\uDC14', color: '#FDE047', category: 'Vinegar', description: 'Honey-mustard meets smoky BBQ.' },
  { id: 34, name: 'Whisky BBQ', emoji: '\uD83E\uDD43', color: '#92400E', category: 'Vinegar', description: 'Boozy smokiness for the bold.' },
  
  // Other sauces
  { id: 35, name: 'Salsa', emoji: '\uD83D\uDC83', color: '#EF4444', category: 'Other', description: 'The life of every party, fresh or jarred.' },
  { id: 36, name: 'Marinara', emoji: '\uD83C\uDF5D', color: '#DC2626', category: 'Other', description: 'Tomato sauce with Italian grandma energy.' },
  { id: 37, name: 'Fish Sauce', emoji: '\uD83D\uDC20', color: '#854D0E', category: 'Other', description: 'Funky, fermented, and irreplaceable.' },
  { id: 38, name: 'Tahini', emoji: '\uD83E\uDED8', color: '#D6D3D1', category: 'Other', description: 'Sesame paste that elevates everything.' },
  { id: 39, name: 'Hummus', emoji: '\uD83E\uDDC6', color: '#D6D3D1', category: 'Other', description: 'Chickpea dip that launched a thousand snacks.' },
  { id: 40, name: 'Satay', emoji: '\uD83E\uDD5C', color: '#D97706', category: 'Other', description: 'Peanutty perfection from Southeast Asia.' },
  { id: 41, name: 'Piccalilli', emoji: '\uD83E\uDD52', color: '#A3E635', category: 'Other', description: 'Chunky British pickle relish.' },
  
  // Uncategorized
  { id: 42, name: 'Honey', emoji: '\uD83C\uDF6F', color: '#F59E0B', category: 'Uncategorized', description: 'Nature\'s sweetener with a sticky agenda.' },
  { id: 43, name: 'Hollandaise', emoji: '\uD83E\uDDC8', color: '#FDE047', category: 'Uncategorized', description: 'Brunch royalty, delicate and demanding.' },
  { id: 44, name: 'Gravy', emoji: '\uD83C\uDF56', color: '#78350F', category: 'Uncategorized', description: 'Comfort in a boat, best served hot.' },
  { id: 45, name: 'Guacamole', emoji: '\uD83E\uDD51', color: '#84CC16', category: 'Uncategorized', description: 'Avocado\'s final form, chunky or smooth.' },
  { id: 46, name: 'Chutney', emoji: '\uD83E\uDD6D', color: '#F97316', category: 'Uncategorized', description: 'Sweet-spicy complexity from the subcontinent.' },
];

const ALIGNMENT_CONFIG = {
  'Lawful Good': { abbr: 'LG', color: '#3B82F6' },
  'Neutral Good': { abbr: 'NG', color: '#22C55E' },
  'Chaotic Good': { abbr: 'CG', color: '#A855F7' },
  'Lawful Neutral': { abbr: 'LN', color: '#6366F1' },
  'True Neutral': { abbr: 'TN', color: '#6B7280' },
  'Chaotic Neutral': { abbr: 'CN', color: '#EC4899' },
  'Lawful Evil': { abbr: 'LE', color: '#F97316' },
  'Neutral Evil': { abbr: 'NE', color: '#EF4444' },
  'Chaotic Evil': { abbr: 'CE', color: '#DC2626' },
};

const STORAGE_KEYS = {
  PLACED_SAUCES: 'sauce-alignment-placed',
  DARK_MODE: 'sauce-alignment-theme',
  MILESTONES: 'sauce-alignment-milestones',
  GAME_START: 'sauce-alignment-start-time',
  SORT_MODE: 'sauce-alignment-sort'
};

const CATEGORY_ORDER = ['Cream', 'Oil', 'Soy', 'Vinegar', 'Other', 'Uncategorized'];

const isDarkColor = (color) => {
  return ['#1C1917', '#292524', '#78350F', '#44403C', '#854D0E'].includes(color);
};

// Helper to format sauce names for display (split multi-word names)
const formatSauceName = (name) => {
  const words = name.split(' ');
  if (words.length >= 2) {
    return words;
  }
  return [name];
};

// Local storage helpers
const loadFromStorage = (key, defaultValue) => {
  try {
    const stored = localStorage.getItem(key);
    if (stored === null) return defaultValue;
    return JSON.parse(stored);
  } catch {
    return defaultValue;
  }
};

const saveToStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage full or unavailable - fail silently
  }
};

const clearGameStorage = () => {
  try {
    // Only clear game state, preserve preferences (dark mode, sort mode)
    localStorage.removeItem(STORAGE_KEYS.PLACED_SAUCES);
    localStorage.removeItem(STORAGE_KEYS.MILESTONES);
    localStorage.removeItem(STORAGE_KEYS.GAME_START);
  } catch {
    // Fail silently
  }
};

// Confetti particle component
const Confetti = ({ particles }) => {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      pointerEvents: 'none',
      zIndex: 9999,
      overflow: 'hidden'
    }}>
      {particles.map((p, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            left: p.x,
            top: p.y,
            fontSize: p.size,
            transform: `rotate(${p.rotation}deg)`,
            animation: `confetti-fall ${p.duration}s ease-out forwards`,
            opacity: p.opacity
          }}
        >
          {p.emoji}
        </div>
      ))}
    </div>
  );
};

// Celebration toast component
const CelebrationToast = ({ message, onDismiss, darkMode }) => {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 2500);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div 
      onClick={onDismiss}
      style={{
        position: 'fixed',
        top: '20%',
        left: '50%',
        transform: 'translateX(-50%)',
        background: darkMode 
          ? 'linear-gradient(145deg, #292524 0%, #1C1917 100%)'
          : 'linear-gradient(145deg, #FFFBF5 0%, #FEF7ED 100%)',
        border: `3px solid ${darkMode ? '#F59E0B' : '#78350F'}`,
        borderRadius: '12px',
        padding: '16px 32px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        zIndex: 10000,
        animation: 'toast-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
        cursor: 'pointer'
      }}
    >
      <div style={{
        fontFamily: "'DM Serif Display', Georgia, serif",
        fontSize: '1.5rem',
        color: darkMode ? '#FEF3C7' : '#78350F',
        textAlign: 'center'
      }}>
        {message}
      </div>
    </div>
  );
};

// Completion stats component
const CompletionStats = ({ placedSauces, calculateAlignment, getAlignmentDisplay, gameStartTime, theme }) => {
  const alignments = placedSauces.map(p => calculateAlignment(p.x, p.y).name);
  const alignmentCounts = alignments.reduce((acc, a) => {
    acc[a] = (acc[a] || 0) + 1;
    return acc;
  }, {});
  const sortedAlignments = Object.entries(alignmentCounts).sort((a, b) => b[1] - a[1]);
  const mostCommon = sortedAlignments[0] || ['True Neutral', 0];
  
  const cornerSauces = placedSauces.filter(p => {
    return (p.x < 20 || p.x > 80) && (p.y < 20 || p.y > 80);
  }).length;
  
  const neutralSauces = placedSauces.filter(p => {
    const alignment = calculateAlignment(p.x, p.y);
    return alignment.name.includes('Neutral');
  }).length;
  
  const timeTaken = Math.floor((Date.now() - gameStartTime) / 1000);
  const minutes = Math.floor(timeTaken / 60);
  const seconds = timeTaken % 60;

  return (
    <>
      <div style={{
        fontFamily: "'Space Mono', monospace",
        fontSize: '0.6875rem',
        color: theme.textMuted,
        marginBottom: '8px'
      }}>
        Most common alignment
      </div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        marginBottom: '16px'
      }}>
        <span 
          style={{
            background: getAlignmentDisplay(mostCommon[0]).color,
            color: '#fff',
            padding: '6px 12px',
            borderRadius: '6px',
            fontFamily: "'Space Mono', monospace",
            fontSize: '0.75rem',
            fontWeight: 700
          }}
        >
          {getAlignmentDisplay(mostCommon[0]).abbr}
        </span>
        <span style={{
          fontFamily: "'DM Serif Display', Georgia, serif",
          fontSize: '1.125rem',
          color: theme.text
        }}>
          {mostCommon[0]}
        </span>
      </div>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '12px',
        textAlign: 'center'
      }}>
        <div>
          <div style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontSize: '1.5rem',
            color: theme.accent
          }}>{cornerSauces}</div>
          <div style={{
            fontFamily: "'Space Mono', monospace",
            fontSize: '0.5625rem',
            color: theme.textMuted,
            textTransform: 'uppercase'
          }}>In corners</div>
        </div>
        <div>
          <div style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontSize: '1.5rem',
            color: theme.accent
          }}>{neutralSauces}</div>
          <div style={{
            fontFamily: "'Space Mono', monospace",
            fontSize: '0.5625rem',
            color: theme.textMuted,
            textTransform: 'uppercase'
          }}>Neutral</div>
        </div>
        <div>
          <div style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontSize: '1.5rem',
            color: theme.accent
          }}>{minutes}:{seconds.toString().padStart(2, '0')}</div>
          <div style={{
            fontFamily: "'Space Mono', monospace",
            fontSize: '0.5625rem',
            color: theme.textMuted,
            textTransform: 'uppercase'
          }}>Time</div>
        </div>
      </div>
    </>
  );
};

export default function SauceAlignmentGame() {
  // Load initial state from localStorage
  const [placedSauces, setPlacedSauces] = useState(() => 
    loadFromStorage(STORAGE_KEYS.PLACED_SAUCES, [])
  );
  const [darkMode, setDarkMode] = useState(() => 
    loadFromStorage(STORAGE_KEYS.DARK_MODE, true)
  );
  const [celebratedMilestones, setCelebratedMilestones] = useState(() => {
    const stored = loadFromStorage(STORAGE_KEYS.MILESTONES, []);
    return new Set(stored);
  });
  const [gameStartTime, setGameStartTime] = useState(() => 
    loadFromStorage(STORAGE_KEYS.GAME_START, Date.now())
  );
  const [sortMode, setSortMode] = useState(() => 
    loadFromStorage(STORAGE_KEYS.SORT_MODE, 'alpha') // 'alpha' or 'category'
  );
  
  const [draggingId, setDraggingId] = useState(null);
  const [selectedSauce, setSelectedSauce] = useState(null);
  const [showAlignmentList, setShowAlignmentList] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [touchDrag, setTouchDrag] = useState(null);
  const [carouselDrag, setCarouselDrag] = useState(null);
  const [hoveredSauceIndex, setHoveredSauceIndex] = useState(null);
  const [hoveredCarouselSauce, setHoveredCarouselSauce] = useState(null);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [desktopDragPos, setDesktopDragPos] = useState(null);
  const [dragGhost, setDragGhost] = useState(null); // { x, y, color } for ghost outline during drag
  const [recentlyPlacedIndex, setRecentlyPlacedIndex] = useState(null); // For success flash animation
  const [confettiParticles, setConfettiParticles] = useState([]);
  const [celebrationToast, setCelebrationToast] = useState(null);
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [carouselScrollPercent, setCarouselScrollPercent] = useState(0);
  const [scrubberDrag, setScrubberDrag] = useState(null);
  
  // Roulette state
  const [roulettePhase, setRoulettePhase] = useState(null); // null | 'rolling' | 'landed' | 'spotlight'
  const [rouletteSauce, setRouletteSauce] = useState(null);
  const [rollingEmoji, setRollingEmoji] = useState(null);
  const [rollingFrame, setRollingFrame] = useState(0); // For re-triggering animation
  const [burstParticles, setBurstParticles] = useState([]); // Confetti burst particles
  
  // Wobble animation state
  const [wobblingIndex, setWobblingIndex] = useState(null); // Index of sauce currently wobbling
  
  // Expandable list state
  const [expandedListItem, setExpandedListItem] = useState(null); // Name of expanded sauce in list
  
  // Share image state
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareImageUrl, setShareImageUrl] = useState(null);
  const [isGeneratingImage, setIsGeneratingImage] = useState(false);
  
  const gridRef = useRef(null);
  const carouselRef = useRef(null);
  const scrubberTrackRef = useRef(null);

  // Persist state changes to localStorage
  useEffect(() => {
    saveToStorage(STORAGE_KEYS.PLACED_SAUCES, placedSauces);
  }, [placedSauces]);

  useEffect(() => {
    saveToStorage(STORAGE_KEYS.DARK_MODE, darkMode);
  }, [darkMode]);

  useEffect(() => {
    saveToStorage(STORAGE_KEYS.MILESTONES, [...celebratedMilestones]);
  }, [celebratedMilestones]);

  useEffect(() => {
    saveToStorage(STORAGE_KEYS.GAME_START, gameStartTime);
  }, [gameStartTime]);

  useEffect(() => {
    saveToStorage(STORAGE_KEYS.SORT_MODE, sortMode);
  }, [sortMode]);

  // Track carousel scroll position for scrubber
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const updateScrollPercent = () => {
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      if (maxScroll > 0) {
        setCarouselScrollPercent(carousel.scrollLeft / maxScroll);
      } else {
        setCarouselScrollPercent(0);
      }
    };

    carousel.addEventListener('scroll', updateScrollPercent);
    // Initial calculation
    updateScrollPercent();
    
    // Recalculate when sauces change
    const resizeObserver = new ResizeObserver(updateScrollPercent);
    resizeObserver.observe(carousel);

    return () => {
      carousel.removeEventListener('scroll', updateScrollPercent);
      resizeObserver.disconnect();
    };
  }, [placedSauces.length, sortMode]);

  // Scrubber drag handlers
  const handleScrubberMouseDown = (e) => {
    e.preventDefault();
    const track = scrubberTrackRef.current;
    if (!track) return;
    
    const rect = track.getBoundingClientRect();
    setScrubberDrag({ trackLeft: rect.left, trackWidth: rect.width });
    
    // Immediately jump to click position
    const percent = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    scrollCarouselToPercent(percent);
  };

  const handleScrubberMouseMove = useCallback((e) => {
    if (!scrubberDrag) return;
    const percent = Math.max(0, Math.min(1, (e.clientX - scrubberDrag.trackLeft) / scrubberDrag.trackWidth));
    scrollCarouselToPercent(percent);
  }, [scrubberDrag]);

  const handleScrubberMouseUp = useCallback(() => {
    setScrubberDrag(null);
  }, []);

  // Touch handlers for scrubber (mobile support)
  const handleScrubberTouchStart = (e) => {
    e.preventDefault();
    const track = scrubberTrackRef.current;
    if (!track) return;
    
    const touch = e.touches[0];
    const rect = track.getBoundingClientRect();
    setScrubberDrag({ trackLeft: rect.left, trackWidth: rect.width });
    
    // Immediately jump to touch position
    const percent = Math.max(0, Math.min(1, (touch.clientX - rect.left) / rect.width));
    scrollCarouselToPercent(percent);
  };

  const handleScrubberTouchMove = useCallback((e) => {
    if (!scrubberDrag) return;
    const touch = e.touches[0];
    const percent = Math.max(0, Math.min(1, (touch.clientX - scrubberDrag.trackLeft) / scrubberDrag.trackWidth));
    scrollCarouselToPercent(percent);
  }, [scrubberDrag]);

  const handleScrubberTouchEnd = useCallback(() => {
    setScrubberDrag(null);
  }, []);

  // Global mouse events for scrubber drag
  useEffect(() => {
    if (scrubberDrag) {
      window.addEventListener('mousemove', handleScrubberMouseMove);
      window.addEventListener('mouseup', handleScrubberMouseUp);
      window.addEventListener('touchmove', handleScrubberTouchMove, { passive: false });
      window.addEventListener('touchend', handleScrubberTouchEnd);
      return () => {
        window.removeEventListener('mousemove', handleScrubberMouseMove);
        window.removeEventListener('mouseup', handleScrubberMouseUp);
        window.removeEventListener('touchmove', handleScrubberTouchMove);
        window.removeEventListener('touchend', handleScrubberTouchEnd);
      };
    }
  }, [scrubberDrag, handleScrubberMouseMove, handleScrubberMouseUp, handleScrubberTouchMove, handleScrubberTouchEnd]);

  const scrollCarouselToPercent = (percent) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    carousel.scrollLeft = percent * maxScroll;
  };

  // Theme colors
  const theme = darkMode ? {
    bg: 'linear-gradient(135deg, #1C1917 0%, #292524 50%, #1C1917 100%)',
    cardBg: 'linear-gradient(145deg, #292524 0%, #1C1917 100%)',
    text: '#FEF3C7',
    textMuted: '#A8A29E',
    border: '#44403C',
    accent: '#F59E0B',
    gridBg: 'radial-gradient(ellipse at center, #292524 0%, #1C1917 100%)',
    gridLines: 'rgba(254, 243, 199, 0.1)',
    axisColor: '#F59E0B',
    carouselBg: 'linear-gradient(180deg, #292524 0%, #1C1917 100%)',
    carouselBorder: '#44403C',
    overlayBg: 'rgba(0, 0, 0, 0.7)',
  } : {
    bg: 'linear-gradient(135deg, #FEF7ED 0%, #FFF7ED 50%, #FFFBEB 100%)',
    cardBg: 'linear-gradient(145deg, #FFFBF5 0%, #FEF7ED 100%)',
    text: '#78350F',
    textMuted: '#A16207',
    border: '#D6B899',
    accent: '#78350F',
    gridBg: 'radial-gradient(ellipse at center, #FFFBF5 0%, #FEF3E2 100%)',
    gridLines: 'rgba(120, 53, 15, 0.03)',
    axisColor: '#78350F',
    carouselBg: 'linear-gradient(180deg, #FFFBF5 0%, #FEF7ED 100%)',
    carouselBorder: '#D6B899',
    overlayBg: 'rgba(120, 53, 15, 0.3)',
  };

  // Prevent background scroll when modals are open
  useEffect(() => {
    if (showAlignmentList || selectedSauce || showSettings || showShareModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showAlignmentList, selectedSauce, showSettings, showShareModal]);

  // Celebration milestones
  const CONFETTI_EMOJIS = ['\uD83C\uDF45', '\uD83C\uDF36\uFE0F', '\uD83E\uDD6B', '\uD83E\uDDC8', '\uD83C\uDF6F', '\uD83E\uDD44', '\uD83C\uDF89', '\u2728'];
  
  const spawnConfetti = useCallback((intensity = 1) => {
    const particleCount = Math.floor(30 * intensity);
    const newParticles = [];
    
    for (let i = 0; i < particleCount; i++) {
      newParticles.push({
        x: `${Math.random() * 100}%`,
        y: -20,
        emoji: CONFETTI_EMOJIS[Math.floor(Math.random() * CONFETTI_EMOJIS.length)],
        size: `${16 + Math.random() * 16}px`,
        rotation: Math.random() * 360,
        duration: 2 + Math.random() * 2,
        opacity: 0.8 + Math.random() * 0.2
      });
    }
    
    setConfettiParticles(newParticles);
    setTimeout(() => setConfettiParticles([]), 4000);
  }, []);

  // Check for milestones when sauces are placed
  useEffect(() => {
    const count = placedSauces.length;
    const total = SAUCES.length;
    
    const milestones = [
      { threshold: 25, message: '\uD83E\uDD44 Quarter of the way!', intensity: 0.5 },
      { threshold: 50, message: '\uD83C\uDF7D\uFE0F Halfway there!', intensity: 1 },
      { threshold: 75, message: '\uD83D\uDC68\u200D\uD83C\uDF73 Almost done!', intensity: 1.5 },
      { threshold: 100, message: '\uD83C\uDF89 Chart Complete!', intensity: 2, isComplete: true }
    ];
    
    for (const milestone of milestones) {
      const requiredCount = Math.ceil((milestone.threshold / 100) * total);
      if (count >= requiredCount && !celebratedMilestones.has(milestone.threshold)) {
        setCelebratedMilestones(prev => new Set([...prev, milestone.threshold]));
        spawnConfetti(milestone.intensity);
        
        if (milestone.isComplete) {
          setTimeout(() => setShowCompletionModal(true), 500);
        } else {
          setCelebrationToast(milestone.message);
        }
        break;
      }
    }
  }, [placedSauces.length, celebratedMilestones, spawnConfetti]);

  // Auto-dismiss celebration toast
  useEffect(() => {
    if (celebrationToast) {
      const timer = setTimeout(() => setCelebrationToast(null), 2500);
      return () => clearTimeout(timer);
    }
  }, [celebrationToast]);

  // Sauce wobble animation - random sauce wobbles every 8-10 seconds
  useEffect(() => {
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;
    
    // Only run if there are unlocked placed sauces
    const unlockedIndices = placedSauces
      .map((s, i) => ({ index: i, locked: s.locked }))
      .filter(s => !s.locked)
      .map(s => s.index);
    
    if (unlockedIndices.length === 0) {
      setWobblingIndex(null);
      return;
    }
    
    // Pick a random interval between 8-10 seconds
    const interval = 8000 + Math.random() * 2000;
    
    const timer = setInterval(() => {
      // Pick a random unlocked sauce
      const randomIndex = unlockedIndices[Math.floor(Math.random() * unlockedIndices.length)];
      setWobblingIndex(randomIndex);
      
      // Clear wobble after animation completes (500ms)
      setTimeout(() => setWobblingIndex(null), 500);
    }, interval);
    
    return () => clearInterval(timer);
  }, [placedSauces]);

  const placedIds = placedSauces.map(s => s.sauceId);
  const availableSauces = SAUCES.filter(s => !placedIds.includes(s.id));
  
  // Sort available sauces based on mode
  const sortedAvailableSauces = [...availableSauces].sort((a, b) => {
    if (sortMode === 'category') {
      const catDiff = CATEGORY_ORDER.indexOf(a.category) - CATEGORY_ORDER.indexOf(b.category);
      if (catDiff !== 0) return catDiff;
    }
    return a.name.localeCompare(b.name);
  });

  // Group sauces by category for display (when in category mode)
  const groupedSauces = sortMode === 'category' 
    ? CATEGORY_ORDER.reduce((acc, cat) => {
        const sauces = sortedAvailableSauces.filter(s => s.category === cat);
        if (sauces.length > 0) {
          acc.push({ category: cat, sauces });
        }
        return acc;
      }, [])
    : null;

  // Toggle lock on spacebar, remove on Delete/Backspace when hovering a sauce
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (hoveredSauceIndex !== null && !showAlignmentList && !selectedSauce && !showSettings && !showShareModal) {
        if (e.code === 'Space') {
          e.preventDefault();
          setPlacedSauces(prev => prev.map((item, i) => 
            i === hoveredSauceIndex ? { ...item, locked: !item.locked } : item
          ));
        } else if (e.code === 'Delete' || e.code === 'Backspace') {
          e.preventDefault();
          // Don't allow removing locked sauces
          if (!placedSauces[hoveredSauceIndex]?.locked) {
            setPlacedSauces(prev => prev.filter((_, i) => i !== hoveredSauceIndex));
            setHoveredSauceIndex(null);
          }
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [hoveredSauceIndex, showAlignmentList, selectedSauce, showSettings, showShareModal, placedSauces]);

  const handleDragStart = (e, sauce, isPlaced = false, placedIndex = null) => {
    // Prevent dragging locked sauces
    if (isPlaced && placedSauces[placedIndex]?.locked) {
      e.preventDefault();
      return;
    }
    
    e.dataTransfer.effectAllowed = 'move';
    
    // Get the sauce tile element for the drag image
    // For placed sauces, find the .sauce-tile child; for carousel, use the .sauce-card itself
    let dragElement;
    if (isPlaced) {
      dragElement = e.currentTarget.querySelector('.sauce-tile') || e.currentTarget;
    } else {
      dragElement = e.currentTarget;
    }
    
    const rect = dragElement.getBoundingClientRect();
    
    // Center the drag image on the cursor
    e.dataTransfer.setDragImage(dragElement, rect.width / 2, rect.height / 2);
    
    if (isPlaced) {
      setDraggingId({ type: 'placed', index: placedIndex, sauce });
      // Set ghost outline at original position
      const placed = placedSauces[placedIndex];
      setDragGhost({ x: placed.x, y: placed.y, color: sauce.color });
    } else {
      setDraggingId({ type: 'palette', sauce });
      setHoveredCarouselSauce(null); // Hide name label while dragging
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    // Track position for desktop drag indicator
    if (draggingId && gridRef.current) {
      const rect = gridRef.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      
      if (x >= 0 && x <= 100 && y >= 0 && y <= 100) {
        setDesktopDragPos({
          clientX: e.clientX,
          clientY: e.clientY,
          gridX: Math.max(0, Math.min(100, x)),
          gridY: Math.max(0, Math.min(100, y)),
          alignment: calculateAlignment(x, y)
        });
      } else {
        setDesktopDragPos(null);
      }
    }
  };

  const handleDropOnGrid = (e) => {
    e.preventDefault();
    if (!draggingId || !gridRef.current) return;

    // Use the tracked position from dragOver for more accurate placement
    // Fall back to drop event coordinates if tracking failed
    let clampedX, clampedY;
    
    if (desktopDragPos) {
      clampedX = desktopDragPos.gridX;
      clampedY = desktopDragPos.gridY;
    } else {
      const rect = gridRef.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      clampedX = Math.max(0, Math.min(100, x));
      clampedY = Math.max(0, Math.min(100, y));
    }

    if (draggingId.type === 'palette') {
      setPlacedSauces(prev => [...prev, {
        sauceId: draggingId.sauce.id,
        x: clampedX,
        y: clampedY,
        locked: false
      }]);
      // Trigger success flash for newly placed sauce
      setRecentlyPlacedIndex(placedSauces.length); // Will be the index of the new sauce
    } else {
      setPlacedSauces(prev => prev.map((item, i) => 
        i === draggingId.index ? { ...item, x: clampedX, y: clampedY } : item
      ));
      // Trigger success flash for repositioned sauce
      setRecentlyPlacedIndex(draggingId.index);
    }
    setDraggingId(null);
    setDesktopDragPos(null);
    setDragGhost(null);
    
    // Clear flash after animation completes
    setTimeout(() => setRecentlyPlacedIndex(null), 600);
  };

  const handleDragEnd = () => {
    setDraggingId(null);
    setDesktopDragPos(null);
    setDragGhost(null);
  };

  const handleDropOnPalette = (e) => {
    e.preventDefault();
    if (draggingId?.type === 'placed') {
      setPlacedSauces(prev => prev.filter((_, i) => i !== draggingId.index));
    }
    setDraggingId(null);
    setDesktopDragPos(null);
    setDragGhost(null);
  };

  const handleReset = () => {
    setPlacedSauces([]);
    setCelebratedMilestones(new Set());
    setGameStartTime(Date.now());
    clearGameStorage();
  };

  const scrollCarousel = useCallback((direction) => {
    if (carouselRef.current) {
      const scrollAmount = 240;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  }, []);

  // Keyboard arrow key support for carousel
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only handle if no modal is open and not handling spacebar for lock
      if (showAlignmentList || selectedSauce || showSettings) return;
      
      if (e.key === 'ArrowLeft') {
        scrollCarousel('left');
      } else if (e.key === 'ArrowRight') {
        scrollCarousel('right');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showAlignmentList, selectedSauce, showSettings, scrollCarousel]);

  // Carousel drag-to-scroll handlers
  const handleCarouselMouseDown = (e) => {
    // Only initiate drag scroll on the carousel background, not on sauce cards
    if (e.target.closest('.sauce-card')) return;
    
    if (carouselRef.current) {
      setCarouselDrag({
        isActive: true,
        startX: e.clientX,
        scrollLeft: carouselRef.current.scrollLeft
      });
    }
  };

  const handleCarouselMouseMove = useCallback((e) => {
    if (!carouselDrag?.isActive || !carouselRef.current) return;
    
    e.preventDefault();
    const dx = e.clientX - carouselDrag.startX;
    carouselRef.current.scrollLeft = carouselDrag.scrollLeft - dx;
  }, [carouselDrag]);

  const handleCarouselMouseUp = useCallback(() => {
    if (carouselDrag?.isActive) {
      setCarouselDrag(null);
    }
  }, [carouselDrag]);

  // Global mouse move/up for carousel drag
  useEffect(() => {
    if (carouselDrag?.isActive) {
      window.addEventListener('mousemove', handleCarouselMouseMove);
      window.addEventListener('mouseup', handleCarouselMouseUp);
      return () => {
        window.removeEventListener('mousemove', handleCarouselMouseMove);
        window.removeEventListener('mouseup', handleCarouselMouseUp);
      };
    }
  }, [carouselDrag, handleCarouselMouseMove, handleCarouselMouseUp]);

  // Touch drag handlers for mobile
  const handleTouchStart = (e, sauce, isPlaced = false, placedIndex = null) => {
    // Prevent dragging locked sauces
    if (isPlaced && placedSauces[placedIndex]?.locked) {
      return;
    }
    
    const touch = e.touches[0];
    const rect = e.target.getBoundingClientRect();
    setTouchDrag({
      sauce,
      isPlaced,
      placedIndex,
      startX: touch.clientX,
      startY: touch.clientY,
      currentX: touch.clientX,
      currentY: touch.clientY,
      offsetX: touch.clientX - rect.left,
      offsetY: touch.clientY - rect.top,
      gridCoords: null
    });
    
    // Set ghost outline for placed sauce
    if (isPlaced) {
      const placed = placedSauces[placedIndex];
      setDragGhost({ x: placed.x, y: placed.y, color: sauce.color });
    }
  };

  const handleTouchMove = (e) => {
    if (!touchDrag) return;
    e.preventDefault();
    const touch = e.touches[0];
    
    let gridCoords = null;
    if (gridRef.current) {
      const rect = gridRef.current.getBoundingClientRect();
      const x = ((touch.clientX - rect.left) / rect.width) * 100;
      const y = ((touch.clientY - rect.top) / rect.height) * 100;
      
      if (x >= 0 && x <= 100 && y >= 0 && y <= 100) {
        gridCoords = {
          x: Math.max(0, Math.min(100, x)),
          y: Math.max(0, Math.min(100, y)),
          alignment: calculateAlignment(x, y)
        };
      }
    }
    
    setTouchDrag(prev => ({
      ...prev,
      currentX: touch.clientX,
      currentY: touch.clientY,
      gridCoords
    }));
  };

  const handleTouchEnd = () => {
    if (!touchDrag) return;
    
    if (touchDrag.gridCoords) {
      const { x, y } = touchDrag.gridCoords;
      
      if (touchDrag.isPlaced) {
        setPlacedSauces(prev => prev.map((item, i) => 
          i === touchDrag.placedIndex ? { ...item, x, y } : item
        ));
        // Trigger success flash
        setRecentlyPlacedIndex(touchDrag.placedIndex);
      } else {
        setPlacedSauces(prev => [...prev, {
          sauceId: touchDrag.sauce.id,
          x,
          y,
          locked: false
        }]);
        // Trigger success flash for newly placed sauce
        setRecentlyPlacedIndex(placedSauces.length);
      }
      // Clear flash after animation completes
      setTimeout(() => setRecentlyPlacedIndex(null), 600);
    }
    
    setTouchDrag(null);
    setDragGhost(null);
  };

  const getAlignmentDisplay = (alignmentName) => {
    const config = ALIGNMENT_CONFIG[alignmentName];
    return config || { abbr: '??', color: '#6B7280' };
  };

  const getSauceById = (id) => SAUCES.find(s => s.id === id);

  const calculateAlignment = (x, y) => {
    const NEUTRAL_ZONE = 5;
    
    let lawfulChaotic;
    if (x >= 50 - NEUTRAL_ZONE && x <= 50 + NEUTRAL_ZONE) {
      lawfulChaotic = 'Neutral';
    } else if (x < 50) {
      lawfulChaotic = 'Lawful';
    } else {
      lawfulChaotic = 'Chaotic';
    }
    
    let goodEvil;
    if (y >= 50 - NEUTRAL_ZONE && y <= 50 + NEUTRAL_ZONE) {
      goodEvil = 'Neutral';
    } else if (y < 50) {
      goodEvil = 'Good';
    } else {
      goodEvil = 'Evil';
    }
    
    const lcIntensity = Math.round(Math.abs(x - 50) * 2);
    const geIntensity = Math.round(Math.abs(y - 50) * 2);
    
    let alignmentName;
    if (lawfulChaotic === 'Neutral' && goodEvil === 'Neutral') {
      alignmentName = 'True Neutral';
    } else if (lawfulChaotic === 'Neutral') {
      alignmentName = `Neutral ${goodEvil}`;
    } else if (goodEvil === 'Neutral') {
      alignmentName = `${lawfulChaotic} Neutral`;
    } else {
      alignmentName = `${lawfulChaotic} ${goodEvil}`;
    }
    
    return {
      name: alignmentName,
      lawfulChaotic,
      goodEvil,
      lcIntensity,
      geIntensity
    };
  };

  const handleSauceClick = (e, placed, index) => {
    e.stopPropagation();
    const sauce = getSauceById(placed.sauceId);
    const alignment = calculateAlignment(placed.x, placed.y);
    setSelectedSauce({
      sauce,
      placed,
      index,
      alignment
    });
  };

  const closeTooltip = () => {
    setSelectedSauce(null);
  };

  const toggleAlignmentList = () => {
    setShowAlignmentList(prev => !prev);
    setExpandedListItem(null); // Reset expanded item when toggling
  };

  // Roulette handlers
  const startRoulette = useCallback(() => {
    if (availableSauces.length === 0) return;
    
    setRoulettePhase('rolling');
    setRollingFrame(0);
    
    // If only one sauce, skip animation
    if (availableSauces.length === 1) {
      setRouletteSauce(availableSauces[0]);
      setRoulettePhase('spotlight');
      return;
    }
    
    // Slot machine animation - cycle through emojis ensuring variety
    let frame = 0;
    const totalFrames = 20; // Number of emoji changes
    const baseDelay = 50; // Starting speed (ms)
    let lastIndex = -1;
    
    const animate = () => {
      // Pick a different sauce than the last one shown
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * availableSauces.length);
      } while (newIndex === lastIndex && availableSauces.length > 1);
      lastIndex = newIndex;
      
      setRollingEmoji(availableSauces[newIndex].emoji);
      setRollingFrame(frame); // Update frame to re-trigger animation
      frame++;
      
      if (frame < totalFrames) {
        // Gradually slow down (easing)
        const delay = baseDelay + (frame * frame * 2);
        setTimeout(animate, delay);
      } else {
        // Transition to landed phase with burst effect
        const finalSauce = availableSauces[lastIndex];
        setRouletteSauce(finalSauce);
        setRoulettePhase('landed');
        
        // Generate burst particles (cone from both sides)
        const particles = [];
        const particleCount = 12; // Per side
        const burstEmojis = [finalSauce.emoji, '\u2728', '\u2B50', '\uD83C\uDF1F'];
        
        // Left cone (shooting leftward with up/down spread)
        for (let i = 0; i < particleCount; i++) {
          const angle = 150 + (Math.random() * 60); // 150 to 210 degrees (left cone)
          const speed = 80 + Math.random() * 60;
          const rad = (angle * Math.PI) / 180;
          particles.push({
            id: `l${i}`,
            emoji: burstEmojis[Math.floor(Math.random() * burstEmojis.length)],
            dx: Math.cos(rad) * speed,
            dy: Math.sin(rad) * speed,
            rotation: Math.random() * 360,
            scale: 0.5 + Math.random() * 0.5,
            delay: Math.random() * 0.1
          });
        }
        
        // Right cone (shooting rightward with up/down spread)
        for (let i = 0; i < particleCount; i++) {
          const angle = -30 + (Math.random() * 60); // -30 to 30 degrees (right cone)
          const speed = 80 + Math.random() * 60;
          const rad = (angle * Math.PI) / 180;
          particles.push({
            id: `r${i}`,
            emoji: burstEmojis[Math.floor(Math.random() * burstEmojis.length)],
            dx: Math.cos(rad) * speed,
            dy: Math.sin(rad) * speed,
            rotation: Math.random() * 360,
            scale: 0.5 + Math.random() * 0.5,
            delay: Math.random() * 0.1
          });
        }
        
        setBurstParticles(particles);
        
        // Transition to spotlight after burst animation
        setTimeout(() => {
          setRollingEmoji(null);
          setBurstParticles([]);
          setRoulettePhase('spotlight');
        }, 800);
      }
    };
    
    animate();
  }, [availableSauces]);

  const cancelRoulette = useCallback(() => {
    setRoulettePhase(null);
    setRouletteSauce(null);
    setRollingEmoji(null);
    setBurstParticles([]);
  }, []);

  const placeRouletteAtPosition = useCallback((x, y) => {
    if (!rouletteSauce) return;
    
    setPlacedSauces(prev => [...prev, {
      sauceId: rouletteSauce.id,
      x,
      y,
      locked: false
    }]);
    
    // Trigger success flash
    setRecentlyPlacedIndex(placedSauces.length);
    setTimeout(() => setRecentlyPlacedIndex(null), 600);
    
    // Close roulette
    cancelRoulette();
  }, [rouletteSauce, placedSauces.length, cancelRoulette]);

  const handleRouletteGridClick = useCallback((e) => {
    if (roulettePhase !== 'spotlight' || !gridRef.current) return;
    
    const rect = gridRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    const clampedX = Math.max(0, Math.min(100, x));
    const clampedY = Math.max(0, Math.min(100, y));
    
    placeRouletteAtPosition(clampedX, clampedY);
  }, [roulettePhase, placeRouletteAtPosition]);

  const getAlignmentList = () => {
    return placedSauces.map(placed => {
      const sauce = getSauceById(placed.sauceId);
      const alignment = calculateAlignment(placed.x, placed.y);
      return {
        name: sauce.name,
        category: sauce.category,
        alignment: alignment.name,
        lawfulChaotic: `${alignment.lcIntensity}% ${alignment.lawfulChaotic}`,
        goodEvil: `${alignment.geIntensity}% ${alignment.goodEvil}`,
        x: Math.round(placed.x),
        y: Math.round(placed.y),
        locked: placed.locked
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  };

  const exportToCSV = () => {
    const list = getAlignmentList();
    if (list.length === 0) return;
    
    const headers = ['Sauce', 'Category', 'Alignment', 'Lawful/Chaotic', 'Good/Evil', 'X Position', 'Y Position', 'Locked'];
    const rows = list.map(item => [
      item.name,
      item.category,
      item.alignment,
      item.lawfulChaotic,
      item.goodEvil,
      item.x,
      item.y,
      item.locked ? 'Yes' : 'No'
    ]);
    
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'sauce-alignment.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Generate shareable chart image
  const generateShareImage = useCallback(async () => {
    if (placedSauces.length === 0) return;
    
    setIsGeneratingImage(true);
    
    // Use setTimeout to allow UI to update before heavy canvas work
    await new Promise(resolve => setTimeout(resolve, 50));
    
    try {
      const canvas = document.createElement('canvas');
      const size = 1200;
      const padding = 80;
      const gridSize = size - (padding * 2);
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      
      // Colors based on current theme
      const colors = darkMode ? {
        bg: '#1C1917',
        gridBg: '#292524',
        gridLines: 'rgba(254, 243, 199, 0.08)',
        axisLine: '#F59E0B',
        text: '#FEF3C7',
        textMuted: '#A8A29E',
        quadrantLG: 'rgba(59, 130, 246, 0.06)',
        quadrantCG: 'rgba(168, 85, 247, 0.06)',
        quadrantLE: 'rgba(249, 115, 22, 0.06)',
        quadrantCE: 'rgba(220, 38, 38, 0.06)',
      } : {
        bg: '#FEF7ED',
        gridBg: '#FFFBF5',
        gridLines: 'rgba(120, 53, 15, 0.05)',
        axisLine: '#78350F',
        text: '#78350F',
        textMuted: '#A16207',
        quadrantLG: 'rgba(59, 130, 246, 0.04)',
        quadrantCG: 'rgba(168, 85, 247, 0.04)',
        quadrantLE: 'rgba(249, 115, 22, 0.04)',
        quadrantCE: 'rgba(220, 38, 38, 0.04)',
      };
      
      // Fill background
      ctx.fillStyle = colors.bg;
      ctx.fillRect(0, 0, size, size);
      
      // Draw grid background
      ctx.fillStyle = colors.gridBg;
      ctx.fillRect(padding, padding, gridSize, gridSize);
      
      // Draw quadrant tinting
      const halfGrid = gridSize / 2;
      ctx.fillStyle = colors.quadrantLG;
      ctx.fillRect(padding, padding, halfGrid, halfGrid);
      ctx.fillStyle = colors.quadrantCG;
      ctx.fillRect(padding + halfGrid, padding, halfGrid, halfGrid);
      ctx.fillStyle = colors.quadrantLE;
      ctx.fillRect(padding, padding + halfGrid, halfGrid, halfGrid);
      ctx.fillStyle = colors.quadrantCE;
      ctx.fillRect(padding + halfGrid, padding + halfGrid, halfGrid, halfGrid);
      
      // Draw grid lines
      ctx.strokeStyle = colors.gridLines;
      ctx.lineWidth = 1;
      const gridSpacing = 40;
      for (let i = 0; i <= gridSize; i += gridSpacing) {
        // Vertical lines
        ctx.beginPath();
        ctx.moveTo(padding + i, padding);
        ctx.lineTo(padding + i, padding + gridSize);
        ctx.stroke();
        // Horizontal lines
        ctx.beginPath();
        ctx.moveTo(padding, padding + i);
        ctx.lineTo(padding + gridSize, padding + i);
        ctx.stroke();
      }
      
      // Draw axis lines (center cross)
      ctx.strokeStyle = colors.axisLine;
      ctx.lineWidth = 3;
      // Vertical axis
      ctx.beginPath();
      ctx.moveTo(padding + halfGrid, padding);
      ctx.lineTo(padding + halfGrid, padding + gridSize);
      ctx.stroke();
      // Horizontal axis
      ctx.beginPath();
      ctx.moveTo(padding, padding + halfGrid);
      ctx.lineTo(padding + gridSize, padding + halfGrid);
      ctx.stroke();
      
      // Draw border
      ctx.strokeStyle = colors.axisLine;
      ctx.lineWidth = 4;
      ctx.strokeRect(padding, padding, gridSize, gridSize);
      
      // Helper to draw text
      const drawText = (text, x, y, font, color, align = 'center', baseline = 'middle') => {
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.textAlign = align;
        ctx.textBaseline = baseline;
        ctx.fillText(text, x, y);
      };
      
      // Draw corner labels
      const cornerFont = '600 14px "Space Mono", monospace';
      const cornerOffset = 12;
      drawText('LAWFUL GOOD', padding + cornerOffset, padding + cornerOffset + 6, cornerFont, colors.textMuted, 'left', 'top');
      drawText('CHAOTIC GOOD', padding + gridSize - cornerOffset, padding + cornerOffset + 6, cornerFont, colors.textMuted, 'right', 'top');
      drawText('LAWFUL EVIL', padding + cornerOffset, padding + gridSize - cornerOffset - 6, cornerFont, colors.textMuted, 'left', 'bottom');
      drawText('CHAOTIC EVIL', padding + gridSize - cornerOffset, padding + gridSize - cornerOffset - 6, cornerFont, colors.textMuted, 'right', 'bottom');
      
      // Draw axis labels
      const axisFont = '700 16px "Space Mono", monospace';
      drawText('GOOD', padding + halfGrid, padding - 20, axisFont, colors.axisLine);
      drawText('EVIL', padding + halfGrid, padding + gridSize + 28, axisFont, colors.axisLine);
      
      // Rotated labels for left/right
      ctx.save();
      ctx.translate(padding - 28, padding + halfGrid);
      ctx.rotate(-Math.PI / 2);
      drawText('LAWFUL', 0, 0, axisFont, colors.axisLine);
      ctx.restore();
      
      ctx.save();
      ctx.translate(padding + gridSize + 28, padding + halfGrid);
      ctx.rotate(Math.PI / 2);
      drawText('CHAOTIC', 0, 0, axisFont, colors.axisLine);
      ctx.restore();
      
      // Draw placed sauces
      const sauceSize = 48;
      for (const placed of placedSauces) {
        const sauce = getSauceById(placed.sauceId);
        if (!sauce) continue;
        
        const x = padding + (placed.x / 100) * gridSize;
        const y = padding + (placed.y / 100) * gridSize;
        
        // Draw sauce circle background
        ctx.beginPath();
        ctx.arc(x, y, sauceSize / 2 + 4, 0, Math.PI * 2);
        ctx.fillStyle = sauce.color;
        ctx.fill();
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
        ctx.lineWidth = 2;
        ctx.stroke();
        
        // Draw emoji
        ctx.font = '28px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(sauce.emoji, x, y + 2);
      }
      
      // Draw watermark
      const watermarkFont = '400 12px "Space Mono", monospace';
      drawText('sauce.kingfishergames.dev', size / 2, size - 16, watermarkFont, colors.textMuted);
      
      // Convert to data URL
      const dataUrl = canvas.toDataURL('image/png');
      setShareImageUrl(dataUrl);
      setShowShareModal(true);
    } catch (error) {
      console.error('Failed to generate image:', error);
    } finally {
      setIsGeneratingImage(false);
    }
  }, [placedSauces, darkMode, getSauceById]);

  // Download the share image
  const downloadShareImage = useCallback(() => {
    if (!shareImageUrl) return;
    
    const link = document.createElement('a');
    link.href = shareImageUrl;
    link.download = 'sauce-alignment-chart.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [shareImageUrl]);

  // Helper to convert data URL to Blob
  const dataUrlToBlob = useCallback((dataUrl) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }, []);

  // Copy image to clipboard
  const copyShareImage = useCallback(async () => {
    if (!shareImageUrl) return false;
    
    try {
      const blob = dataUrlToBlob(shareImageUrl);
      
      // ClipboardItem can take either a Blob or a Promise<Blob>
      // Using Promise for broader compatibility
      const clipboardItem = new ClipboardItem({
        [blob.type]: Promise.resolve(blob)
      });
      
      await navigator.clipboard.write([clipboardItem]);
      
      return true;
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      
      // Fallback: try copying the data URL as text (less useful but better than nothing)
      try {
        await navigator.clipboard.writeText(shareImageUrl);
        console.log('Copied data URL as text fallback');
        return true;
      } catch (fallbackError) {
        console.error('Fallback copy also failed:', fallbackError);
        return false;
      }
    }
  }, [shareImageUrl, dataUrlToBlob]);

  // Check if Web Share API supports file sharing
  const canShareFiles = useCallback(() => {
    if (!navigator.share || !navigator.canShare) return false;
    
    // Test if file sharing is supported
    try {
      const testFile = new File(['test'], 'test.png', { type: 'image/png' });
      return navigator.canShare({ files: [testFile] });
    } catch {
      return false;
    }
  }, []);

  // Share via Web Share API
  const shareImage = useCallback(async () => {
    if (!shareImageUrl || !navigator.share) return;
    
    try {
      const blob = dataUrlToBlob(shareImageUrl);
      const file = new File([blob], 'sauce-alignment-chart.png', { type: 'image/png' });
      
      await navigator.share({
        files: [file]
      });
    } catch (error) {
      // User cancelled or share failed
      if (error.name !== 'AbortError') {
        console.error('Share failed:', error);
      }
    }
  }, [shareImageUrl, dataUrlToBlob]);

  // Close share modal and cleanup
  const closeShareModal = useCallback(() => {
    setShowShareModal(false);
    // Delay cleanup to allow modal animation
    setTimeout(() => {
      if (shareImageUrl) {
        setShareImageUrl(null);
      }
    }, 200);
  }, [shareImageUrl]);

  const lockedCount = placedSauces.filter(s => s.locked).length;

  return (
    <div 
      style={{
        minHeight: '100vh',
        maxHeight: '100vh',
        background: theme.bg,
        fontFamily: "'DM Serif Display', Georgia, serif",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        boxSizing: 'border-box',
        transition: 'background 0.3s ease',
        overflow: 'hidden'
      }}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <style>{`
        * { box-sizing: border-box; }
        
        .sauce-card {
          cursor: grab;
          transition: all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
          user-select: none;
          flex-shrink: 0;
          touch-action: none;
        }
        .sauce-card:hover {
          transform: translateY(-4px) scale(1.05);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
        }
        .sauce-card:active {
          cursor: grabbing;
          transform: scale(1.08);
        }
        .sauce-card.disabled {
          cursor: not-allowed;
          pointer-events: none;
        }
        .sauce-card.disabled:hover {
          transform: none;
          box-shadow: none;
        }
        
        .placed-sauce {
          cursor: grab;
          transition: transform 0.15s ease;
          touch-action: none;
        }
        .placed-sauce:hover {
          transform: translate(-50%, -50%) scale(1.08);
          z-index: 100;
        }
        .placed-sauce:hover > .sauce-tile {
          box-shadow: 0 8px 24px rgba(0,0,0,0.3);
        }
        .placed-sauce:active {
          cursor: grabbing;
        }
        .placed-sauce.locked {
          cursor: not-allowed;
        }
        .placed-sauce.locked:hover {
          transform: translate(-50%, -50%) scale(1.02);
        }
        
        .sauce-tile {
          transition: opacity 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
          opacity: 0.65;
        }
        
        .placed-sauce.locked > .sauce-tile {
          opacity: 0.85;
        }
        
        .placed-sauce:hover > .sauce-tile,
        .placed-sauce.locked:hover > .sauce-tile {
          opacity: 1 !important;
        }
        
        .sauce-tile.flash {
          animation: placement-flash 0.6s ease-out;
        }
        
        @keyframes placement-flash {
          0% {
            box-shadow: 0 0 0 0 ${theme.accent}aa, 0 6px 16px rgba(0,0,0,0.2);
          }
          50% {
            box-shadow: 0 0 0 12px ${theme.accent}00, 0 6px 16px rgba(0,0,0,0.2);
          }
          100% {
            box-shadow: 0 0 0 0 ${theme.accent}00, 0 6px 16px rgba(0,0,0,0.2);
          }
        }
        
        .sauce-tile.wobble {
          animation: sauce-wobble 0.5s ease-in-out;
        }
        
        @keyframes sauce-wobble {
          0%, 100% { transform: rotate(0deg) scale(1); }
          25% { transform: rotate(-3deg) scale(1.03); }
          75% { transform: rotate(3deg) scale(1.02); }
        }
        
        @media (prefers-reduced-motion: reduce) {
          .sauce-tile.wobble {
            animation: none;
          }
        }
        
        .drag-ghost {
          position: absolute;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          border: 3px dashed ${theme.accent};
          opacity: 0.5;
          pointer-events: none;
          animation: ghost-pulse 1s ease-in-out infinite;
        }
        
        @keyframes ghost-pulse {
          0%, 100% { opacity: 0.3; transform: translate(-50%, -50%) scale(1); }
          50% { opacity: 0.6; transform: translate(-50%, -50%) scale(1.05); }
        }
        
        .sauce-name-label {
          opacity: 0;
          transform: translateX(-50%) translateY(-8px);
          transition: all 0.2s ease;
          pointer-events: none;
        }
        .placed-sauce:hover .sauce-name-label {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
        
        .settings-btn {
          position: fixed;
          top: 16px;
          right: 16px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid ${theme.border};
          background: ${darkMode ? '#292524' : '#FFFBF5'};
          color: ${theme.text};
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.125rem;
          transition: all 0.2s ease;
          z-index: 50;
        }
        .settings-btn:hover {
          transform: rotate(45deg) scale(1.1);
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
        }
        
        .grid-container {
          position: relative;
          background: 
            linear-gradient(${theme.gridLines} 1px, transparent 1px),
            linear-gradient(90deg, ${theme.gridLines} 1px, transparent 1px),
            ${theme.gridBg};
          background-size: 40px 40px, 40px 40px, 100% 100%;
          border: 3px solid ${theme.accent};
          border-radius: 4px;
          box-shadow: 
            inset 0 0 60px ${darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(120, 53, 15, 0.05)'},
            0 4px 24px ${darkMode ? 'rgba(0,0,0,0.4)' : 'rgba(120, 53, 15, 0.1)'};
          transition: all 0.3s ease;
          user-select: none;
        }
        
        .quadrant {
          position: absolute;
          width: 50%;
          height: 50%;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }
        .quadrant-lg { top: 0; left: 0; background: ${darkMode ? 'rgba(59, 130, 246, 0.04)' : 'rgba(59, 130, 246, 0.03)'}; }
        .quadrant-cg { top: 0; right: 0; background: ${darkMode ? 'rgba(168, 85, 247, 0.04)' : 'rgba(168, 85, 247, 0.03)'}; }
        .quadrant-le { bottom: 0; left: 0; background: ${darkMode ? 'rgba(249, 115, 22, 0.04)' : 'rgba(249, 115, 22, 0.03)'}; }
        .quadrant-ce { bottom: 0; right: 0; background: ${darkMode ? 'rgba(220, 38, 38, 0.04)' : 'rgba(220, 38, 38, 0.03)'}; }
        
        .grid-empty-state {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          animation: empty-state-pulse 2s ease-in-out infinite;
        }
        .grid-empty-state-text {
          font-family: 'Space Mono', monospace;
          font-size: 0.75rem;
          color: ${theme.textMuted};
          text-transform: uppercase;
          letter-spacing: 1px;
          text-align: center;
          margin-bottom: 8px;
        }
        .grid-empty-state-arrow {
          font-size: 1.5rem;
          color: ${theme.accent};
          animation: bounce-down 1.5s ease-in-out infinite;
        }
        @keyframes empty-state-pulse {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.85; transform: scale(1.08); }
        }
        @keyframes bounce-down {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(8px); }
        }
        
        .axis-label {
          font-family: 'Space Mono', monospace;
          font-size: 0.6875rem;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: ${theme.accent};
          position: absolute;
          user-select: none;
        }
        
        .carousel-container {
          background: ${theme.carouselBg};
          border: 2px dashed ${theme.carouselBorder};
          border-radius: 12px;
          transition: all 0.2s ease;
          overflow: visible;
        }
        .carousel-container.drag-over {
          background: ${darkMode ? '#44403C' : '#FEF3C7'};
          border-color: ${theme.accent};
        }
        .carousel-container.grabbing {
          cursor: grabbing;
        }
        
        .carousel-scroll {
          display: flex;
          gap: 12px;
          overflow-x: auto;
          scroll-behavior: auto;
          padding: 12px 8px;
          scrollbar-width: none;
          -ms-overflow-style: none;
          cursor: grab;
        }
        .carousel-scroll::-webkit-scrollbar {
          display: none;
        }
        .carousel-scroll.grabbing {
          cursor: grabbing;
          scroll-behavior: auto;
        }
        
        .carousel-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
          transition: all 0.2s ease;
          z-index: 10;
          user-select: none;
        }
        .carousel-btn:hover {
          background: ${darkMode ? '#D97706' : '#92400E'};
          transform: translateY(-50%) scale(1.1);
        }
        .carousel-btn:active {
          transform: translateY(-50%) scale(0.95);
        }
        .carousel-btn.left { left: -16px; }
        .carousel-btn.right { right: -16px; }
        
        .category-separator {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 6px;
          flex-shrink: 0;
          height: 56px;
          cursor: default;
        }
        .category-separator-line {
          width: 2px;
          height: 32px;
          background: ${theme.border};
          border-radius: 1px;
        }
        .category-separator:hover .category-separator-line {
          background: ${theme.accent};
        }
        
        .category-floating-label {
          position: absolute;
          bottom: 100%;
          transform: translateX(-50%);
          margin-bottom: 4px;
          padding: 4px 8px;
          background: ${darkMode ? 'rgba(28,25,23,0.95)' : 'rgba(255,251,245,0.95)'};
          border-radius: 4px;
          text-align: center;
          white-space: nowrap;
          pointer-events: none;
          z-index: 200;
          animation: fadeIn 0.15s ease;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;
        }
        .category-floating-label span {
          font-size: 0.5625rem;
          font-family: 'Space Mono', monospace;
          font-weight: 700;
          color: ${darkMode ? '#FEF3C7' : '#78350F'};
          text-transform: uppercase;
          letter-spacing: 0.3px;
        }
        .category-floating-label .arrow {
          font-size: 0.625rem;
          color: ${theme.accent};
        }
        
        .scrubber-container {
          margin-top: 8px;
          user-select: none;
        }
        .scrubber-hint {
          text-align: center;
          font-family: 'Space Mono', monospace;
          font-size: 0.5625rem;
          color: ${theme.textMuted};
          opacity: 0.6;
          margin-bottom: 6px;
        }
        .scrubber-track {
          position: relative;
          height: 12px;
          background: ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.1)'};
          border-radius: 6px;
          cursor: pointer;
          overflow: visible;
          touch-action: none;
          /* Larger touch target via padding */
          padding: 10px 0;
          margin: -10px 0;
          background-clip: content-box;
        }
        .scrubber-track:hover {
          background: ${darkMode ? 'rgba(255,255,255,0.15)' : 'rgba(120, 53, 15, 0.15)'};
        }
        .scrubber-handle {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 1.5rem;
          cursor: grab;
          transition: transform 0.1s ease;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
          /* Larger touch target */
          padding: 8px;
          margin: -8px;
        }
        .scrubber-handle:hover {
          transform: translate(-50%, -50%) scale(1.15);
        }
        .scrubber-handle:active, .scrubber-handle.dragging {
          cursor: grabbing;
          transform: translate(-50%, -50%) scale(1.2);
        }
        .scrubber-progress {
          position: absolute;
          left: 0;
          top: 10px;
          height: 12px;
          background: ${theme.accent};
          border-radius: 6px;
          opacity: 0.4;
          pointer-events: none;
        }
        
        .reset-btn {
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          background: transparent;
          color: ${theme.textMuted};
          border: 2px solid ${theme.border};
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .reset-btn:hover {
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
          border-color: ${theme.accent};
        }
        .reset-btn:active {
          transform: scale(0.95);
        }
        
        .dice-btn {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          background: transparent;
          border: 2px solid ${theme.border};
          color: ${theme.textMuted};
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          transition: all 0.2s ease;
        }
        .dice-btn:hover:not(:disabled) {
          background: ${theme.accent};
          border-color: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
          transform: scale(1.1) rotate(15deg);
        }
        .dice-btn:active:not(:disabled) {
          transform: scale(0.95) rotate(-10deg);
        }
        .dice-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        
        .roulette-overlay {
          position: absolute;
          inset: 0;
          background: ${darkMode ? 'rgba(0,0,0,0.7)' : 'rgba(120, 53, 15, 0.3)'};
          backdrop-filter: blur(2px);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 200;
          animation: fadeIn 0.2s ease;
          cursor: pointer;
        }
        
        .roulette-rolling {
          font-size: 4rem;
        }
        
        .roulette-rolling-emoji {
          display: inline-block;
          animation: slot-pop 0.15s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        
        @keyframes slot-pop {
          0% { transform: translateY(-20px) scale(0.7); opacity: 0; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        
        .roulette-landed {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .roulette-landed-emoji {
          font-size: 4rem;
          animation: landed-bounce 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        
        @keyframes landed-bounce {
          0% { transform: scale(1); }
          50% { transform: scale(1.3); }
          100% { transform: scale(1); }
        }
        
        .burst-container {
          position: absolute;
          width: 0;
          height: 0;
          pointer-events: none;
        }
        
        .burst-particle {
          position: absolute;
          font-size: 2.5rem;
          animation: burst-fly 0.7s ease-out forwards;
        }
        
        @keyframes burst-fly {
          0% {
            transform: translate(0, 0) scale(1) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translate(var(--dx), var(--dy)) scale(0.3) rotate(var(--rot));
            opacity: 0;
          }
        }
        
        .roulette-spotlight {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          animation: spotlight-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          cursor: default;
        }
        
        @keyframes spotlight-pop {
          0% { transform: scale(0.5); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        
        .spotlight-tile {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
          border: 3px solid rgba(255,255,255,0.8);
          box-shadow: 
            0 8px 32px rgba(0,0,0,0.4),
            0 0 0 4px ${theme.accent}40,
            0 0 40px ${theme.accent}30;
          animation: spotlight-glow 2s ease-in-out infinite;
        }
        
        @keyframes spotlight-glow {
          0%, 100% { box-shadow: 0 8px 32px rgba(0,0,0,0.4), 0 0 0 4px ${theme.accent}40, 0 0 40px ${theme.accent}30; }
          50% { box-shadow: 0 8px 32px rgba(0,0,0,0.4), 0 0 0 8px ${theme.accent}60, 0 0 60px ${theme.accent}50; }
        }
        
        .spotlight-name {
          font-family: 'DM Serif Display', Georgia, serif;
          font-size: 1.25rem;
          color: ${darkMode ? '#FEF3C7' : '#78350F'};
          text-shadow: 0 2px 8px rgba(0,0,0,0.5);
        }
        
        .spotlight-category {
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          padding: 4px 10px;
          background: ${darkMode ? 'rgba(255,255,255,0.15)' : 'rgba(120, 53, 15, 0.15)'};
          color: ${darkMode ? '#FEF3C7' : '#78350F'};
          border-radius: 4px;
        }
        
        .spotlight-hint {
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          color: ${darkMode ? '#A8A29E' : '#A16207'};
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-top: 8px;
          animation: hint-pulse 1.5s ease-in-out infinite;
        }
        
        @keyframes hint-pulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
        
        .spotlight-actions {
          display: flex;
          gap: 8px;
          margin-top: 8px;
        }
        
        .spotlight-btn {
          padding: 8px 16px;
          border-radius: 6px;
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .spotlight-btn.primary {
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
          border: none;
        }
        .spotlight-btn.primary:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        }
        .spotlight-btn.secondary {
          background: transparent;
          color: ${darkMode ? '#FEF3C7' : '#78350F'};
          border: 2px solid ${darkMode ? 'rgba(255,255,255,0.3)' : 'rgba(120, 53, 15, 0.3)'};
        }
        .spotlight-btn.secondary:hover {
          background: ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.1)'};
        }
        
        .corner-label {
          font-family: 'Space Mono', monospace;
          font-size: 0.5625rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          color: ${theme.textMuted};
          opacity: 0.6;
          user-select: none;
          pointer-events: none;
        }
        
        .title {
          font-family: 'DM Serif Display', Georgia, serif;
          font-size: clamp(1.5rem, 4vw, 2.25rem);
          color: ${theme.text};
          text-align: center;
          margin: 0;
          letter-spacing: -1px;
          cursor: pointer;
          transition: all 0.2s ease;
          display: inline-block;
          position: relative;
        }
        .title:hover {
          color: ${theme.accent};
          transform: scale(1.02);
        }
        .title:hover::after {
          width: 100%;
        }
        .title::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 2px;
          background: ${theme.border};
          transition: width 0.3s ease;
          border-radius: 2px;
        }
        
        .title-hint {
          font-family: 'Space Mono', monospace;
          font-size: 0.5625rem;
          color: ${theme.textMuted};
          text-transform: uppercase;
          letter-spacing: 1px;
          opacity: 0;
          transition: opacity 0.2s ease;
          margin-top: 2px;
        }
        .title-wrapper:hover .title-hint {
          opacity: 1;
        }
        
        .alignment-list-overlay {
          position: fixed;
          inset: 0;
          background: ${theme.overlayBg};
          backdrop-filter: blur(2px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          animation: fadeIn 0.15s ease;
        }
        
        .alignment-list-card {
          background: ${theme.cardBg};
          border: 3px solid ${theme.accent};
          border-radius: 12px;
          padding: 24px;
          width: 90%;
          max-width: 500px;
          max-height: 80vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
          animation: slideUp 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
        }
        
        .alignment-list-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          padding-bottom: 16px;
          padding-right: 40px;
          border-bottom: 2px solid ${theme.border};
        }
        
        .alignment-list-title {
          font-family: 'DM Serif Display', Georgia, serif;
          font-size: 1.5rem;
          color: ${theme.text};
          margin: 0;
        }
        
        .alignment-list-scroll {
          overflow-y: auto;
          flex: 1;
          margin: 0 -8px;
          padding: 0 8px;
        }
        
        .alignment-list-item {
          background: ${darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(120, 53, 15, 0.03)'};
          border-radius: 8px;
          margin-bottom: 8px;
          transition: background 0.15s ease;
          overflow: hidden;
        }
        .alignment-list-item:hover {
          background: ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.08)'};
        }
        
        .alignment-list-item-header {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px;
          cursor: pointer;
        }
        
        .alignment-list-chevron {
          font-size: 0.75rem;
          color: ${theme.textMuted};
          transition: transform 0.2s ease;
          flex-shrink: 0;
          margin-left: auto;
        }
        .alignment-list-chevron.expanded {
          transform: rotate(180deg);
        }
        
        .alignment-list-description {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.2s ease, padding 0.2s ease;
        }
        .alignment-list-description.expanded {
          max-height: 100px;
        }
        .alignment-list-description-content {
          padding: 0 12px 12px 64px;
          font-family: 'Space Mono', monospace;
          font-size: 0.6875rem;
          color: ${theme.textMuted};
          line-height: 1.5;
          text-align: justify;
          hyphens: auto;
        }
        
        .alignment-list-empty {
          text-align: center;
          padding: 40px 20px;
          color: ${theme.textMuted};
          font-family: 'Space Mono', monospace;
          font-size: 0.75rem;
        }
        
        .export-btn {
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          background: transparent;
          color: ${theme.text};
          border: 2px solid ${theme.accent};
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .export-btn:hover {
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
        }
        .export-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        
        .counter {
          font-family: 'Space Mono', monospace;
          font-size: 0.6875rem;
          color: ${theme.textMuted};
        }
        
        .empty-state {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          min-height: 72px;
          text-align: center;
          color: ${theme.textMuted};
          font-family: 'Space Mono', monospace;
          font-size: 0.6875rem;
          letter-spacing: 1px;
          padding: 12px;
        }
        
        .tooltip-overlay {
          position: fixed;
          inset: 0;
          background: ${theme.overlayBg};
          backdrop-filter: blur(2px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          animation: fadeIn 0.15s ease;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(16px) scale(0.95);
          }
          to { 
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        
        @keyframes confetti-fall {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
        
        @keyframes toast-pop {
          0% {
            opacity: 0;
            transform: translateX(-50%) scale(0.8) translateY(-20px);
          }
          100% {
            opacity: 1;
            transform: translateX(-50%) scale(1) translateY(0);
          }
        }
        
        .tooltip-card {
          background: ${theme.cardBg};
          border: 3px solid ${theme.accent};
          border-radius: 12px;
          padding: 24px;
          min-width: 280px;
          max-width: 320px;
          box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
          animation: slideUp 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        
        .tooltip-close {
          position: absolute;
          top: 12px;
          right: 12px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: transparent;
          border: 2px solid ${theme.border};
          color: ${theme.textMuted};
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          transition: all 0.15s ease;
        }
        .tooltip-close:hover {
          background: ${theme.accent};
          border-color: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
        }
        
        .share-modal {
          background: ${theme.cardBg};
          border: 3px solid ${theme.accent};
          border-radius: 12px;
          padding: 24px;
          width: 90%;
          max-width: 420px;
          max-height: 90vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
          animation: slideUp 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
        }
        
        .share-preview {
          width: 100%;
          aspect-ratio: 1;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 16px;
          background: ${darkMode ? '#1C1917' : '#FEF7ED'};
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .share-preview img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        
        .share-actions {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }
        
        .share-btn {
          flex: 1;
          min-width: 100px;
          padding: 12px 16px;
          border-radius: 6px;
          font-family: 'Space Mono', monospace;
          font-size: 0.6875rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        .share-btn.primary {
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
          border: none;
        }
        .share-btn.primary:hover {
          transform: scale(1.02);
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        }
        .share-btn.secondary {
          background: transparent;
          color: ${theme.text};
          border: 2px solid ${theme.border};
        }
        .share-btn.secondary:hover {
          background: ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.1)'};
        }
        .share-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .share-generating {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          padding: 40px 20px;
        }
        
        .share-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid ${theme.border};
          border-top-color: ${theme.accent};
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        .share-trigger-btn {
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          background: transparent;
          color: ${theme.text};
          border: 2px solid ${theme.accent};
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .share-trigger-btn:hover {
          background: ${theme.accent};
          color: ${darkMode ? '#1C1917' : '#FFFBF5'};
        }
        .share-trigger-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        
        .alignment-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 6px;
          font-family: 'Space Mono', monospace;
          font-size: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          color: #fff;
        }
        
        .alignment-meters {
          display: flex;
          gap: 12px;
          margin-top: 12px;
        }
        
        .meter {
          flex: 1;
        }
        
        .meter-label {
          font-family: 'Space Mono', monospace;
          font-size: 0.5625rem;
          color: ${theme.textMuted};
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-bottom: 4px;
          display: flex;
          justify-content: space-between;
        }
        
        .meter-bar {
          height: 6px;
          background: ${darkMode ? '#44403C' : '#E7D5C4'};
          border-radius: 3px;
          overflow: hidden;
        }
        
        .meter-fill {
          height: 100%;
          background: ${theme.accent};
          border-radius: 3px;
          transition: width 0.3s ease;
        }
        
        .drag-indicator {
          position: fixed;
          pointer-events: none;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        
        .drag-indicator-icon {
          width: 56px;
          height: 56px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.75rem;
          border: 3px solid rgba(255,255,255,0.8);
          box-shadow: 0 8px 24px rgba(0,0,0,0.4);
        }
        
        .drag-indicator-coords {
          margin-bottom: 8px;
          padding: 6px 10px;
          background: ${darkMode ? '#292524' : '#FFFBF5'};
          border: 2px solid ${theme.accent};
          border-radius: 6px;
          font-family: 'Space Mono', monospace;
          font-size: 0.625rem;
          font-weight: 700;
          color: ${theme.text};
          white-space: nowrap;
        }
        
        .settings-modal {
          background: ${theme.cardBg};
          border: 3px solid ${theme.accent};
          border-radius: 12px;
          padding: 24px;
          width: 90%;
          max-width: 320px;
          box-shadow: 0 24px 48px rgba(0, 0, 0, 0.4);
          animation: slideUp 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
        }
        
        .toggle-switch {
          position: relative;
          width: 52px;
          height: 28px;
          background: ${darkMode ? '#44403C' : '#E7D5C4'};
          border-radius: 14px;
          cursor: pointer;
          transition: background 0.2s ease;
        }
        .toggle-switch.active {
          background: ${theme.accent};
        }
        .toggle-switch::after {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: 24px;
          height: 24px;
          background: #fff;
          border-radius: 50%;
          transition: transform 0.2s ease;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        .toggle-switch.active::after {
          transform: translateX(24px);
        }
        
        .header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }
        
        .lock-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          width: 18px;
          height: 18px;
          background: ${theme.accent};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.625rem;
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
          border: 2px solid ${darkMode ? '#1C1917' : '#FFFBF5'};
        }
        
        /* Responsive sizing for larger screens */
        @media (min-width: 768px) {
          .main-container {
            max-width: 640px !important;
          }
        }
        @media (min-width: 1024px) {
          .main-container {
            max-width: 720px !important;
          }
        }
        @media (min-width: 1440px) {
          .main-container {
            max-width: 800px !important;
          }
        }
      `}</style>

      {/* Settings Button */}
      <button 
        className="settings-btn"
        onClick={() => setShowSettings(true)}
        aria-label="Settings"
      >
        {'\u2699'}{'\uFE0F'}
      </button>

      <div 
        className="main-container"
        style={{ 
          width: '100%', 
          maxWidth: '560px',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'calc(100vh - 32px)'
        }}
      >
        {/* Header: Title + Counter */}
        <div className="header-row">
          <div className="title-wrapper">
            <h1 className="title" onClick={toggleAlignmentList}>
              Sauce Alignment
            </h1>
            <p className="title-hint">Click for list</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span className="counter">
              {placedSauces.length}/{SAUCES.length}
              {lockedCount > 0 && ` ${'\u2022'} ${'\uD83D\uDD12'}${lockedCount}`}
            </span>
            <button 
              className="dice-btn"
              onClick={startRoulette}
              disabled={availableSauces.length === 0 || roulettePhase === 'rolling' || roulettePhase === 'landed'}
              title={availableSauces.length === 0 ? 'All sauces placed!' : 'Random sauce'}
              aria-label="Random sauce"
            >
              {'\uD83C\uDFB2'}
            </button>
            <button className="reset-btn" onClick={handleReset}>
              Reset
            </button>
          </div>
        </div>

        {/* Alignment Grid */}
        <div style={{ position: 'relative', marginBottom: '32px', flex: '1 1 auto', minHeight: 0 }}>
          {/* Axis Labels */}
          <div className="axis-label" style={{ top: '-20px', left: '50%', transform: 'translateX(-50%)' }}>
            Good
          </div>
          <div className="axis-label" style={{ bottom: '-24px', left: '50%', transform: 'translateX(-50%)' }}>
            Evil
          </div>
          <div className="axis-label" style={{ left: '-40px', top: '50%', transform: 'translateY(-50%) rotate(-90deg)' }}>
            Lawful
          </div>
          <div className="axis-label" style={{ right: '-44px', top: '50%', transform: 'translateY(-50%) rotate(90deg)' }}>
            Chaotic
          </div>

          <div 
            ref={gridRef}
            className="grid-container"
            style={{
              aspectRatio: '1',
              width: '100%',
              maxHeight: 'calc(100vh - 220px)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onDragOver={handleDragOver}
            onDrop={handleDropOnGrid}
          >
            {/* Quadrant Tinting */}
            <div className="quadrant quadrant-lg" />
            <div className="quadrant quadrant-cg" />
            <div className="quadrant quadrant-le" />
            <div className="quadrant quadrant-ce" />

            {/* Axis Lines */}
            <div style={{
              position: 'absolute',
              left: '50%',
              top: 0,
              bottom: 0,
              width: '2px',
              background: `linear-gradient(180deg, ${theme.accent} 0%, ${darkMode ? 'rgba(245,158,11,0.3)' : 'rgba(120,53,15,0.3)'} 50%, ${theme.accent} 100%)`,
              transform: 'translateX(-50%)',
              zIndex: 1
            }} />
            <div style={{
              position: 'absolute',
              top: '50%',
              left: 0,
              right: 0,
              height: '2px',
              background: `linear-gradient(90deg, ${theme.accent} 0%, ${darkMode ? 'rgba(245,158,11,0.3)' : 'rgba(120,53,15,0.3)'} 50%, ${theme.accent} 100%)`,
              transform: 'translateY(-50%)',
              zIndex: 1
            }} />

            {/* Corner Labels */}
            <span className="corner-label" style={{ position: 'absolute', top: 8, left: 8, zIndex: 2 }}>Lawful Good</span>
            <span className="corner-label" style={{ position: 'absolute', top: 8, right: 8, textAlign: 'right', zIndex: 2 }}>Chaotic Good</span>
            <span className="corner-label" style={{ position: 'absolute', bottom: 8, left: 8, zIndex: 2 }}>Lawful Evil</span>
            <span className="corner-label" style={{ position: 'absolute', bottom: 8, right: 8, textAlign: 'right', zIndex: 2 }}>Chaotic Evil</span>

            {/* Empty State */}
            {placedSauces.length === 0 && (
              <div className="grid-empty-state">
                <div className="grid-empty-state-text">
                  Drag sauces here<br />to begin
                </div>
                <div className="grid-empty-state-arrow">{'\u2193'}</div>
              </div>
            )}

            {/* Ghost Outline (shows original position while dragging) */}
            {dragGhost && (
              <div 
                className="drag-ghost"
                style={{
                  left: `${dragGhost.x}%`,
                  top: `${dragGhost.y}%`,
                  width: 'clamp(40px, 7vw, 48px)',
                  height: 'clamp(40px, 7vw, 48px)',
                  borderColor: dragGhost.color,
                  zIndex: 5
                }}
              />
            )}

            {/* Placed Sauces */}
            {placedSauces.map((placed, index) => {
              const sauce = getSauceById(placed.sauceId);
              const nameLines = formatSauceName(sauce.name);
              const isLocked = placed.locked;
              const isBeingDragged = draggingId?.type === 'placed' && draggingId?.index === index;
              const isRecentlyPlaced = recentlyPlacedIndex === index;
              const isWobbling = wobblingIndex === index && !isLocked;
              return (
                <div
                  key={`${placed.sauceId}-${index}`}
                  className={`placed-sauce ${isLocked ? 'locked' : ''}`}
                  draggable={!isLocked}
                  onDragStart={(e) => handleDragStart(e, sauce, true, index)}
                  onDragEnd={handleDragEnd}
                  onTouchStart={(e) => handleTouchStart(e, sauce, true, index)}
                  onClick={(e) => handleSauceClick(e, placed, index)}
                  onMouseEnter={() => setHoveredSauceIndex(index)}
                  onMouseLeave={() => setHoveredSauceIndex(null)}
                  style={{
                    position: 'absolute',
                    left: `${placed.x}%`,
                    top: `${placed.y}%`,
                    transform: 'translate(-50%, -50%)',
                    zIndex: hoveredSauceIndex === index ? 100 : 10,
                    opacity: isBeingDragged ? 0.3 : 1
                  }}
                  title={`${sauce.name}${isLocked ? ' (locked)' : ''} ${'\u2022'} Space: lock ${'\u2022'} Del: remove`}
                >
                  <div 
                    className={`sauce-tile ${isRecentlyPlaced ? 'flash' : ''} ${isWobbling ? 'wobble' : ''}`}
                    style={{
                      width: 'clamp(40px, 7vw, 48px)',
                      height: 'clamp(40px, 7vw, 48px)',
                      borderRadius: '50%', // Circle shape for placed sauces
                      background: `linear-gradient(145deg, ${sauce.color}dd 0%, ${sauce.color} 100%)`,
                      border: isLocked 
                        ? `3px solid ${theme.accent}` 
                        : '2px solid rgba(255,255,255,0.6)',
                      boxShadow: isLocked
                        ? `0 4px 12px rgba(0,0,0,0.2), inset 0 1px 2px rgba(255,255,255,0.3), 0 0 0 2px ${darkMode ? 'rgba(245,158,11,0.3)' : 'rgba(120,53,15,0.2)'}`
                        : '0 6px 16px rgba(0,0,0,0.2), inset 0 1px 2px rgba(255,255,255,0.3)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 'clamp(1.125rem, 3.5vw, 1.5rem)',
                      position: 'relative'
                    }}>
                    {sauce.emoji}
                    {isLocked && (
                      <span className="lock-badge">{'\uD83D\uDD12'}</span>
                    )}
                  </div>
                  <div 
                    className="sauce-name-label"
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: '50%',
                      marginTop: '4px',
                      padding: '3px 6px',
                      background: darkMode ? 'rgba(28,25,23,0.95)' : 'rgba(255,251,245,0.95)',
                      borderRadius: '4px',
                      textAlign: 'center',
                      maxWidth: '80px',
                      lineHeight: 1.2
                    }}
                  >
                    {nameLines.map((line, i) => (
                      <span 
                        key={i}
                        style={{
                          display: 'block',
                          fontSize: 'clamp(0.4375rem, 1.5vw, 0.5625rem)',
                          fontFamily: "'Space Mono', monospace",
                          fontWeight: 700,
                          color: darkMode ? '#FEF3C7' : '#78350F',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          textShadow: darkMode ? '0 1px 2px rgba(0,0,0,0.8)' : '0 1px 2px rgba(255,255,255,0.8)',
                        }}
                      >
                        {line}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}

            {/* Roulette Overlay */}
            {roulettePhase && (
              <div 
                className="roulette-overlay"
                onClick={(e) => {
                  // Click on overlay background to place (in spotlight mode) or cancel
                  if (roulettePhase === 'spotlight') {
                    handleRouletteGridClick(e);
                  }
                }}
              >
                {roulettePhase === 'rolling' && (
                  <div className="roulette-rolling">
                    <span key={rollingFrame} className="roulette-rolling-emoji">
                      {rollingEmoji || '\uD83C\uDFB2'}
                    </span>
                  </div>
                )}
                
                {roulettePhase === 'landed' && rouletteSauce && (
                  <div className="roulette-landed">
                    <div className="burst-container">
                      {burstParticles.map(p => (
                        <div
                          key={p.id}
                          className="burst-particle"
                          style={{
                            '--dx': `${p.dx}px`,
                            '--dy': `${p.dy}px`,
                            '--rot': `${p.rotation}deg`,
                            transform: `scale(${p.scale})`,
                            animationDelay: `${p.delay}s`
                          }}
                        >
                          {p.emoji}
                        </div>
                      ))}
                    </div>
                    <div className="roulette-landed-emoji">
                      {rouletteSauce.emoji}
                    </div>
                  </div>
                )}
                
                {roulettePhase === 'spotlight' && rouletteSauce && (
                  <div className="roulette-spotlight" onClick={(e) => e.stopPropagation()}>
                    <div 
                      className="spotlight-tile"
                      style={{
                        background: `linear-gradient(145deg, ${rouletteSauce.color}dd 0%, ${rouletteSauce.color} 100%)`
                      }}
                    >
                      {rouletteSauce.emoji}
                    </div>
                    <div className="spotlight-name">{rouletteSauce.name}</div>
                    <div className="spotlight-category">{rouletteSauce.category}</div>
                    <div className="spotlight-hint">{'\u2191'} Click on grid to place {'\u2191'}</div>
                    <div className="spotlight-actions">
                      <button 
                        className="spotlight-btn secondary"
                        onClick={cancelRoulette}
                      >
                        {'\u2715'} Cancel
                      </button>
                      <button 
                        className="spotlight-btn primary"
                        onClick={startRoulette}
                      >
                        {'\uD83C\uDFB2'} Re-roll
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Sauce Carousel */}
        <div 
          className={`carousel-container ${carouselDrag?.isActive ? 'grabbing' : ''}`}
          style={{ position: 'relative', flexShrink: 0 }}
          onDragOver={(e) => {
            e.preventDefault();
            e.currentTarget.classList.add('drag-over');
          }}
          onDragLeave={(e) => {
            e.currentTarget.classList.remove('drag-over');
          }}
          onDrop={(e) => {
            e.currentTarget.classList.remove('drag-over');
            handleDropOnPalette(e);
          }}
          onMouseLeave={() => {
            setHoveredCarouselSauce(null);
            setHoveredCategory(null);
          }}
        >
          {/* Floating name tooltip - rendered outside scroll to avoid clipping */}
          {hoveredCarouselSauce && (
            <div 
              style={{
                position: 'absolute',
                bottom: '100%',
                left: hoveredCarouselSauce.x,
                transform: 'translateX(-50%)',
                marginBottom: '4px',
                padding: '4px 8px',
                background: darkMode ? 'rgba(28,25,23,0.95)' : 'rgba(255,251,245,0.95)',
                borderRadius: '4px',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                lineHeight: 1.2,
                pointerEvents: 'none',
                zIndex: 200,
                animation: 'fadeIn 0.15s ease'
              }}
            >
              {formatSauceName(hoveredCarouselSauce.name).map((line, i) => (
                <span 
                  key={i}
                  style={{
                    display: 'block',
                    fontSize: '0.5625rem',
                    fontFamily: "'Space Mono', monospace",
                    fontWeight: 700,
                    color: darkMode ? '#FEF3C7' : '#78350F',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  }}
                >
                  {line}
                </span>
              ))}
            </div>
          )}

          {/* Floating category label - rendered outside scroll to avoid clipping */}
          {hoveredCategory && (
            <div 
              className="category-floating-label"
              style={{ left: hoveredCategory.x }}
            >
              <span>{hoveredCategory.name}</span>
              <span className="arrow">{'\u2192'}</span>
            </div>
          )}
          
          {availableSauces.length > 0 && (
            <>
              <button 
                className="carousel-btn left" 
                onClick={() => scrollCarousel('left')}
                aria-label="Scroll left"
              >
                {'\u2039'}
              </button>
              <button 
                className="carousel-btn right" 
                onClick={() => scrollCarousel('right')}
                aria-label="Scroll right"
              >
                {'\u203A'}
              </button>
            </>
          )}

          <div 
            ref={carouselRef}
            className={`carousel-scroll ${carouselDrag?.isActive ? 'grabbing' : ''}`}
            onMouseDown={handleCarouselMouseDown}
          >
            {availableSauces.length === 0 ? (
              <div className="empty-state" style={{ width: '100%' }}>
                All sauces placed! Drag back here to remove.
              </div>
            ) : sortMode === 'category' && groupedSauces ? (
              // Category-grouped view
              groupedSauces.map((group, groupIndex) => (
                <React.Fragment key={group.category}>
                  <div 
                    className="category-separator"
                    onMouseEnter={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const containerRect = e.currentTarget.closest('.carousel-container').getBoundingClientRect();
                      setHoveredCategory({
                        name: group.category,
                        x: rect.left - containerRect.left + rect.width / 2
                      });
                    }}
                    onMouseLeave={() => setHoveredCategory(null)}
                  >
                    <div className="category-separator-line" />
                  </div>
                  {group.sauces.map(sauce => (
                    <div
                      key={sauce.id}
                      className={`sauce-card ${roulettePhase ? 'disabled' : ''}`}
                      draggable={!roulettePhase}
                      onDragStart={(e) => {
                        if (roulettePhase) { e.preventDefault(); return; }
                        handleDragStart(e, sauce);
                      }}
                      onDragEnd={handleDragEnd}
                      onTouchStart={(e) => {
                        if (roulettePhase) return;
                        handleTouchStart(e, sauce);
                      }}
                      onMouseEnter={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const containerRect = e.currentTarget.closest('.carousel-container').getBoundingClientRect();
                        setHoveredCarouselSauce({
                          name: sauce.name,
                          x: rect.left - containerRect.left + rect.width / 2
                        });
                        setHoveredCategory(null);
                      }}
                      onMouseLeave={() => setHoveredCarouselSauce(null)}
                      style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '8px',
                        background: `linear-gradient(145deg, ${sauce.color}dd 0%, ${sauce.color} 100%)`,
                        border: '2px solid rgba(255,255,255,0.5)',
                        boxShadow: `0 2px 8px ${darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(120, 53, 15, 0.1)'}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        opacity: roulettePhase ? 0.5 : 1
                      }}
                    >
                      <span style={{ fontSize: '1.75rem', lineHeight: 1 }}>{sauce.emoji}</span>
                    </div>
                  ))}
                </React.Fragment>
              ))
            ) : (
              // Alphabetical view
              sortedAvailableSauces.map(sauce => {
                return (
                  <div
                    key={sauce.id}
                    className={`sauce-card ${roulettePhase ? 'disabled' : ''}`}
                    draggable={!roulettePhase}
                    onDragStart={(e) => {
                      if (roulettePhase) { e.preventDefault(); return; }
                      handleDragStart(e, sauce);
                    }}
                    onDragEnd={handleDragEnd}
                    onTouchStart={(e) => {
                      if (roulettePhase) return;
                      handleTouchStart(e, sauce);
                    }}
                    onMouseEnter={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const containerRect = e.currentTarget.closest('.carousel-container').getBoundingClientRect();
                      setHoveredCarouselSauce({
                        name: sauce.name,
                        x: rect.left - containerRect.left + rect.width / 2
                      });
                    }}
                    onMouseLeave={() => setHoveredCarouselSauce(null)}
                    style={{
                      width: '56px',
                      height: '56px',
                      borderRadius: '8px', // Square with rounded corners for carousel
                      background: `linear-gradient(145deg, ${sauce.color}dd 0%, ${sauce.color} 100%)`,
                      border: '2px solid rgba(255,255,255,0.5)',
                      boxShadow: `0 2px 8px ${darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(120, 53, 15, 0.1)'}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      opacity: roulettePhase ? 0.5 : 1
                    }}
                  >
                    <span style={{ fontSize: '1.75rem', lineHeight: 1 }}>{sauce.emoji}</span>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Scrubber and keyboard hints */}
        <div className="scrubber-container">
          <div className="scrubber-hint">
            {'\u2190'} {'\u2192'} scroll {'\u2022'} hover + space lock {'\u2022'} hover + del remove
          </div>
          {availableSauces.length > 0 && (
            <div 
              ref={scrubberTrackRef}
              className="scrubber-track"
              onMouseDown={handleScrubberMouseDown}
              onTouchStart={handleScrubberTouchStart}
            >
              <div 
                className="scrubber-progress"
                style={{ width: `${carouselScrollPercent * 100}%` }}
              />
              <div 
                className={`scrubber-handle ${scrubberDrag ? 'dragging' : ''}`}
                style={{ left: `${carouselScrollPercent * 100}%` }}
              >
                {'\uD83C\uDF7E'}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Desktop Drag Indicator (shows above cursor) */}
      {desktopDragPos && draggingId && (
        <div 
          className="drag-indicator"
          style={{
            left: desktopDragPos.clientX,
            top: desktopDragPos.clientY - 80,
            transform: 'translateX(-50%)'
          }}
        >
          <div className="drag-indicator-coords">
            {getAlignmentDisplay(desktopDragPos.alignment.name).abbr} ({Math.round(desktopDragPos.gridX)}%, {Math.round(desktopDragPos.gridY)}%)
          </div>
        </div>
      )}

      {/* Touch Drag Indicator (shows above finger) */}
      {touchDrag && (
        <div 
          className="drag-indicator"
          style={{
            left: touchDrag.currentX,
            top: touchDrag.currentY - 90,
            transform: 'translateX(-50%)'
          }}
        >
          {touchDrag.gridCoords && (
            <div className="drag-indicator-coords">
              {getAlignmentDisplay(touchDrag.gridCoords.alignment.name).abbr} ({Math.round(touchDrag.gridCoords.x)}%, {Math.round(touchDrag.gridCoords.y)}%)
            </div>
          )}
          <div 
            className="drag-indicator-icon"
            style={{
              background: `linear-gradient(145deg, ${touchDrag.sauce.color}dd 0%, ${touchDrag.sauce.color} 100%)`
            }}
          >
            {touchDrag.sauce.emoji}
          </div>
        </div>
      )}

      {/* Tooltip Modal */}
      {selectedSauce && (
        <div 
          className="tooltip-overlay"
          onClick={closeTooltip}
        >
          <div 
            className="tooltip-card"
            onClick={(e) => e.stopPropagation()}
            style={{ position: 'relative' }}
          >
            <button 
              className="tooltip-close"
              onClick={closeTooltip}
              aria-label="Close"
            >
              {'\u00D7'}
            </button>
            
            {/* Sauce Icon & Name */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '16px',
              marginBottom: '16px'
            }}>
              <div style={{
                width: '72px',
                height: '72px',
                borderRadius: '50%', // Circle in tooltip too
                background: `linear-gradient(145deg, ${selectedSauce.sauce.color}dd 0%, ${selectedSauce.sauce.color} 100%)`,
                border: selectedSauce.placed.locked 
                  ? `3px solid ${theme.accent}`
                  : '2px solid rgba(255,255,255,0.5)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2.25rem',
                flexShrink: 0,
                position: 'relative'
              }}>
                {selectedSauce.sauce.emoji}
                {selectedSauce.placed.locked && (
                  <span style={{
                    position: 'absolute',
                    top: -6,
                    right: -6,
                    width: 22,
                    height: 22,
                    background: theme.accent,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '0.75rem',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    border: `2px solid ${darkMode ? '#1C1917' : '#FFFBF5'}`
                  }}>{'\uD83D\uDD12'}</span>
                )}
              </div>
              <div>
                <h3 style={{
                  fontFamily: "'DM Serif Display', Georgia, serif",
                  fontSize: '1.5rem',
                  color: theme.text,
                  margin: '0 0 8px 0'
                }}>
                  {selectedSauce.sauce.name}
                </h3>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <span 
                    className="alignment-badge"
                    style={{ background: getAlignmentDisplay(selectedSauce.alignment.name).color }}
                    title={selectedSauce.alignment.name}
                  >
                    {getAlignmentDisplay(selectedSauce.alignment.name).abbr}
                  </span>
                  <span style={{
                    display: 'inline-block',
                    padding: '6px 12px',
                    background: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.1)',
                    color: theme.text,
                    borderRadius: '4px',
                    fontFamily: "'Space Mono', monospace",
                    fontSize: '0.6875rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase'
                  }}>
                    {selectedSauce.sauce.category}
                  </span>
                </div>
              </div>
            </div>

            {/* Lock Toggle Button */}
            <button
              onClick={() => {
                setPlacedSauces(prev => prev.map((item, i) => 
                  i === selectedSauce.index ? { ...item, locked: !item.locked } : item
                ));
                setSelectedSauce(prev => ({
                  ...prev,
                  placed: { ...prev.placed, locked: !prev.placed.locked }
                }));
              }}
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '12px',
                background: selectedSauce.placed.locked 
                  ? theme.accent 
                  : (darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.1)'),
                color: selectedSauce.placed.locked 
                  ? (darkMode ? '#1C1917' : '#FFFBF5')
                  : theme.text,
                border: `2px solid ${selectedSauce.placed.locked ? theme.accent : theme.border}`,
                borderRadius: '6px',
                fontFamily: "'Space Mono', monospace",
                fontSize: '0.6875rem',
                fontWeight: 700,
                letterSpacing: '1px',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              {selectedSauce.placed.locked ? '\uD83D\uDD12 Locked' : '\uD83D\uDD13 Unlocked'} 
              <span style={{ opacity: 0.7, fontSize: '0.5625rem' }}>(click to toggle)</span>
            </button>

            {/* Alignment Meters */}
            <div className="alignment-meters">
              <div className="meter">
                <div className="meter-label">
                  <span>Lawful</span>
                  <span>Chaotic</span>
                </div>
                <div className="meter-bar">
                  <div 
                    className="meter-fill" 
                    style={{ 
                      width: `${selectedSauce.placed.x}%`,
                      background: selectedSauce.placed.x > 50 
                        ? `linear-gradient(90deg, ${theme.accent} 0%, #EC4899 100%)`
                        : theme.accent
                    }} 
                  />
                </div>
              </div>
              <div className="meter">
                <div className="meter-label">
                  <span>Good</span>
                  <span>Evil</span>
                </div>
                <div className="meter-bar">
                  <div 
                    className="meter-fill" 
                    style={{ 
                      width: `${selectedSauce.placed.y}%`,
                      background: selectedSauce.placed.y > 50 
                        ? `linear-gradient(90deg, ${theme.accent} 0%, #DC2626 100%)`
                        : theme.accent
                    }} 
                  />
                </div>
              </div>
            </div>

            {/* Percentages */}
            <div style={{
              display: 'flex',
              gap: '12px',
              marginTop: '8px'
            }}>
              <span style={{
                flex: 1,
                fontFamily: "'Space Mono', monospace",
                fontSize: '0.625rem',
                color: theme.text,
                textAlign: 'center'
              }}>
                {selectedSauce.alignment.lcIntensity}% {selectedSauce.alignment.lawfulChaotic !== 'Neutral' ? selectedSauce.alignment.lawfulChaotic : ''}
              </span>
              <span style={{
                flex: 1,
                fontFamily: "'Space Mono', monospace",
                fontSize: '0.625rem',
                color: theme.text,
                textAlign: 'center'
              }}>
                {selectedSauce.alignment.geIntensity}% {selectedSauce.alignment.goodEvil !== 'Neutral' ? selectedSauce.alignment.goodEvil : ''}
              </span>
            </div>

            {/* Description */}
            {selectedSauce.sauce.description && (
              <p style={{
                fontFamily: "'Space Mono', monospace",
                fontSize: '0.75rem',
                color: theme.textMuted,
                lineHeight: 1.5,
                marginTop: '16px',
                padding: '12px',
                background: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(120, 53, 15, 0.05)',
                borderRadius: '6px',
                borderLeft: `3px solid ${theme.border}`,
                textAlign: 'justify',
                hyphens: 'auto'
              }}>
                {selectedSauce.sauce.description}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Alignment List Modal */}
      {showAlignmentList && (
        <div 
          className="alignment-list-overlay"
          onClick={() => setShowAlignmentList(false)}
        >
          <div 
            className="alignment-list-card"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="tooltip-close"
              onClick={() => setShowAlignmentList(false)}
              aria-label="Close"
            >
              {'\u00D7'}
            </button>
            
            <div className="alignment-list-header">
              <h2 className="alignment-list-title">Alignment List</h2>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button 
                  className="share-trigger-btn"
                  onClick={() => {
                    setShowAlignmentList(false);
                    generateShareImage();
                  }}
                  disabled={placedSauces.length === 0 || isGeneratingImage}
                >
                  {'\uD83D\uDCF7'} Share
                </button>
                <button 
                  className="export-btn"
                  onClick={exportToCSV}
                  disabled={placedSauces.length === 0}
                >
                  Export CSV
                </button>
              </div>
            </div>

            <div className="alignment-list-scroll">
              {placedSauces.length === 0 ? (
                <div className="alignment-list-empty">
                  No sauces placed yet.<br />
                  Drag sauces onto the chart to see them here.
                </div>
              ) : (
                getAlignmentList().map((item, index) => {
                  const sauce = SAUCES.find(s => s.name === item.name);
                  const alignmentDisplay = getAlignmentDisplay(item.alignment);
                  const isExpanded = expandedListItem === item.name;
                  return (
                    <div key={index} className="alignment-list-item">
                      <div 
                        className="alignment-list-item-header"
                        onClick={() => setExpandedListItem(isExpanded ? null : item.name)}
                      >
                        <div style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          background: `linear-gradient(145deg, ${sauce.color}dd 0%, ${sauce.color} 100%)`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '1.25rem',
                          flexShrink: 0,
                          position: 'relative',
                          border: item.locked ? `2px solid ${theme.accent}` : 'none'
                        }}>
                          {sauce.emoji}
                          {item.locked && (
                            <span style={{
                              position: 'absolute',
                              top: -4,
                              right: -4,
                              fontSize: '0.625rem'
                            }}>{'\uD83D\uDD12'}</span>
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{
                            fontFamily: "'DM Serif Display', Georgia, serif",
                            fontSize: '1rem',
                            color: theme.text,
                            marginBottom: '2px'
                          }}>
                            {item.name}
                          </div>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span 
                              style={{
                                fontFamily: "'Space Mono', monospace",
                                fontSize: '0.625rem',
                                fontWeight: 700,
                                color: '#fff',
                                background: alignmentDisplay.color,
                                padding: '2px 6px',
                                borderRadius: '3px'
                              }}
                              title={item.alignment}
                            >
                              {alignmentDisplay.abbr}
                            </span>
                            <span style={{
                              fontFamily: "'Space Mono', monospace",
                              fontSize: '0.5625rem',
                              color: theme.text,
                              background: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(120, 53, 15, 0.1)',
                              padding: '2px 6px',
                              borderRadius: '3px'
                            }}>
                              {item.category}
                            </span>
                          </div>
                        </div>
                        <div style={{
                          textAlign: 'right',
                          fontFamily: "'Space Mono', monospace",
                          fontSize: '0.5625rem',
                          color: theme.text,
                          lineHeight: 1.6,
                          marginRight: '8px'
                        }}>
                          <div>{item.lawfulChaotic}</div>
                          <div>{item.goodEvil}</div>
                        </div>
                        <span className={`alignment-list-chevron ${isExpanded ? 'expanded' : ''}`}>
                          {'\u25BC'}
                        </span>
                      </div>
                      <div className={`alignment-list-description ${isExpanded ? 'expanded' : ''}`}>
                        <div className="alignment-list-description-content">
                          {sauce.description}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {placedSauces.length > 0 && (
              <div style={{
                marginTop: '16px',
                paddingTop: '12px',
                borderTop: `2px solid ${theme.border}`,
                fontFamily: "'Space Mono', monospace",
                fontSize: '0.6875rem',
                color: theme.textMuted,
                textAlign: 'center'
              }}>
                {placedSauces.length} sauce{placedSauces.length !== 1 ? 's' : ''} aligned
                {lockedCount > 0 && ` ${'\u2022'} ${lockedCount} locked`}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Settings Modal */}
      {showSettings && (
        <div 
          className="tooltip-overlay"
          onClick={() => setShowSettings(false)}
        >
          <div 
            className="settings-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="tooltip-close"
              onClick={() => setShowSettings(false)}
              aria-label="Close"
            >
              {'\u00D7'}
            </button>
            
            <h2 style={{
              fontFamily: "'DM Serif Display', Georgia, serif",
              fontSize: '1.5rem',
              color: theme.text,
              margin: '0 0 24px 0'
            }}>
              Settings
            </h2>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 0'
            }}>
              <div>
                <div style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  color: theme.text,
                  marginBottom: '4px'
                }}>
                  Light Mode
                </div>
                <div style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.625rem',
                  color: theme.textMuted
                }}>
                  Switch to light theme
                </div>
              </div>
              <div 
                className={`toggle-switch ${!darkMode ? 'active' : ''}`}
                onClick={() => setDarkMode(!darkMode)}
              />
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 0',
              borderTop: `1px solid ${theme.border}`
            }}>
              <div>
                <div style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  color: theme.text,
                  marginBottom: '4px'
                }}>
                  Sort by Category
                </div>
                <div style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.625rem',
                  color: theme.textMuted
                }}>
                  Group sauces by type
                </div>
              </div>
              <div 
                className={`toggle-switch ${sortMode === 'category' ? 'active' : ''}`}
                onClick={() => setSortMode(prev => prev === 'alpha' ? 'category' : 'alpha')}
              />
            </div>

            {/* Storage info */}
            <div style={{
              marginTop: '16px',
              paddingTop: '16px',
              borderTop: `1px solid ${theme.border}`,
              fontFamily: "'Space Mono', monospace",
              fontSize: '0.625rem',
              color: theme.textMuted,
              textAlign: 'center'
            }}>
              Progress auto-saved locally
            </div>
          </div>
        </div>
      )}

      {/* Confetti */}
      {confettiParticles.length > 0 && (
        <div style={{
          position: 'fixed',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 9999,
          overflow: 'hidden'
        }}>
          {confettiParticles.map((p, i) => (
            <div
              key={i}
              style={{
                position: 'absolute',
                left: p.x,
                top: p.y,
                fontSize: p.size,
                transform: `rotate(${p.rotation}deg)`,
                animation: `confetti-fall ${p.duration}s ease-out forwards`,
                opacity: p.opacity
              }}
            >
              {p.emoji}
            </div>
          ))}
        </div>
      )}

      {/* Celebration Toast */}
      {celebrationToast && (
        <div 
          onClick={() => setCelebrationToast(null)}
          style={{
            position: 'fixed',
            top: '20%',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'linear-gradient(145deg, #292524 0%, #1C1917 100%)',
            border: '3px solid #F59E0B',
            borderRadius: '12px',
            padding: '16px 32px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            zIndex: 10000,
            animation: 'toast-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
            cursor: 'pointer'
          }}
        >
          <div style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontSize: '1.5rem',
            color: '#FEF3C7',
            textAlign: 'center'
          }}>
            {celebrationToast}
          </div>
        </div>
      )}

      {/* Completion Modal */}
      {showCompletionModal && (
        <div 
          className="tooltip-overlay"
          onClick={() => setShowCompletionModal(false)}
        >
          <div 
            className="tooltip-card"
            onClick={(e) => e.stopPropagation()}
            style={{ 
              position: 'relative',
              maxWidth: '380px',
              textAlign: 'center'
            }}
          >
            <button 
              className="tooltip-close"
              onClick={() => setShowCompletionModal(false)}
              aria-label="Close"
            >
              {'\u00D7'}
            </button>
            
            <div style={{ fontSize: '3rem', marginBottom: '12px' }}>{'\uD83C\uDF89'}</div>
            
            <h2 style={{
              fontFamily: "'DM Serif Display', Georgia, serif",
              fontSize: '1.75rem',
              color: theme.text,
              margin: '0 0 16px 0'
            }}>
              Chart Complete!
            </h2>
            
            <div style={{
              background: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(120, 53, 15, 0.05)',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <CompletionStats 
                placedSauces={placedSauces}
                calculateAlignment={calculateAlignment}
                getAlignmentDisplay={getAlignmentDisplay}
                gameStartTime={gameStartTime}
                theme={theme}
              />
            </div>
            
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => {
                  setShowCompletionModal(false);
                  generateShareImage();
                }}
                disabled={isGeneratingImage}
                style={{
                  padding: '10px 16px',
                  background: theme.accent,
                  color: darkMode ? '#1C1917' : '#FFFBF5',
                  border: 'none',
                  borderRadius: '6px',
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.625rem',
                  fontWeight: 700,
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                {'\uD83D\uDCF7'} Share
              </button>
              <button
                onClick={() => {
                  setShowCompletionModal(false);
                  toggleAlignmentList();
                }}
                style={{
                  padding: '10px 16px',
                  background: 'transparent',
                  color: theme.text,
                  border: `2px solid ${theme.border}`,
                  borderRadius: '6px',
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.625rem',
                  fontWeight: 700,
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                View List
              </button>
              <button
                onClick={() => {
                  setShowCompletionModal(false);
                  handleReset();
                }}
                style={{
                  padding: '10px 16px',
                  background: 'transparent',
                  color: theme.text,
                  border: `2px solid ${theme.border}`,
                  borderRadius: '6px',
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.625rem',
                  fontWeight: 700,
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                Play Again
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Share Modal */}
      {showShareModal && (
        <div 
          className="tooltip-overlay"
          onClick={closeShareModal}
        >
          <div 
            className="share-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="tooltip-close"
              onClick={closeShareModal}
              aria-label="Close"
            >
              {'\u00D7'}
            </button>
            
            <h2 style={{
              fontFamily: "'DM Serif Display', Georgia, serif",
              fontSize: '1.5rem',
              color: theme.text,
              margin: '0 0 16px 0',
              textAlign: 'center'
            }}>
              Share Your Chart
            </h2>

            {isGeneratingImage ? (
              <div className="share-generating">
                <div className="share-spinner" />
                <span style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.75rem',
                  color: theme.textMuted
                }}>
                  Generating image...
                </span>
              </div>
            ) : shareImageUrl ? (
              <>
                <div className="share-preview">
                  <img src={shareImageUrl} alt="Your Sauce Alignment Chart" />
                </div>
                
                <div className="share-actions">
                  <button 
                    className="share-btn primary"
                    onClick={downloadShareImage}
                  >
                    {'\u2B07'} Download
                  </button>
                  
                  {navigator.clipboard && window.ClipboardItem && (
                    <button 
                      className="share-btn secondary"
                      onClick={async (e) => {
                        const btn = e.currentTarget;
                        const originalText = btn.innerHTML;
                        const success = await copyShareImage();
                        if (success) {
                          btn.innerHTML = '\u2713 Copied!';
                        } else {
                          btn.innerHTML = '\u2717 Failed';
                        }
                        setTimeout(() => { btn.innerHTML = originalText; }, 1500);
                      }}
                    >
                      {'\uD83D\uDCCB'} Copy
                    </button>
                  )}
                  
                  {canShareFiles() && (
                    <button 
                      className="share-btn secondary"
                      onClick={shareImage}
                    >
                      {'\uD83D\uDCE4'} Share
                    </button>
                  )}
                </div>
                
                <p style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.625rem',
                  color: theme.textMuted,
                  textAlign: 'center',
                  marginTop: '12px',
                  marginBottom: 0
                }}>
                  1200x1200px PNG - perfect for social media
                </p>
              </>
            ) : (
              <div className="share-generating">
                <span style={{
                  fontFamily: "'Space Mono', monospace",
                  fontSize: '0.75rem',
                  color: theme.textMuted
                }}>
                  Something went wrong. Please try again.
                </span>
                <button 
                  className="share-btn primary"
                  onClick={generateShareImage}
                  style={{ marginTop: '12px' }}
                >
                  Retry
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
